// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/book-car/book-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/chooseUs/bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/faq/veloz.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/banners/bg02.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/hero/camry.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/banners/book-banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/banners/bg-contact.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  font-size: 62.5%;
  scroll-behavior: smooth;
}

body {
  background-color: #ffffff;
  font-family: "Poppins", sans-serif;
  position: relative;
}

.container {
  max-width: 133rem !important;
  margin: 0 auto !important;
  padding: 0 2.5rem !important;
}

/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: #f5272b #ffffff;
}

/* Chrome, Edge and Safari */
*::-webkit-scrollbar {
  width: 10px;
}

*::-webkit-scrollbar-track {
  border-radius: 5px;
  background-color: #ffffff;
}

*::-webkit-scrollbar-track:hover {
  background-color: #ffffff;
}

*::-webkit-scrollbar-track:active {
  background-color: #ffffff;
}

*::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background-color: #f5272b;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #f5272b;
}

*::-webkit-scrollbar-thumb:active {
  background-color: #ff2525;
}

input[type=file]::file-selector-button {
  background-color: #f5272b;
  border: none;
  color: #fff;
  font-size: 10px;
  padding: 6px;
  font-weight: 700;
  border-radius: 4px;
  margin-top: -6px;
  margin-bottom: -6px;
}

.loading_wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8rem;
}
.loading_wrapper img {
  width: 200px;
}

.not-found-wrapp {
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  flex-direction: column;
  font-size: 2rem;
  font-weight: 500;
  margin-top: 4rem;
  margin-bottom: -10rem;
}
.not-found-wrapp img {
  width: 380px;
}

.input-container {
  display: flex;
  justify-content: end;
  width: 100%;
  position: fixed;
  top: -100px;
  left: 50%;
  z-index: 5;
  transform: translateX(-50%);
  transition: top 0.3s ease-in-out;
  background-color: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(10px);
  padding: 10px;
  border: none;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease-in-out, backdrop-filter 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}
.input-container input {
  outline: none;
  background-color: rgba(255, 255, 255, 0.45);
  color: #878585;
  border-radius: 1rem;
  border: 1px solid #ccd7e6;
  width: 50%;
  padding: 0.8rem;
}

.input-container.show {
  top: 0;
}

.input-datetime[type=datetime-local] {
  outline: none;
  color: #878585;
  padding-right: 3rem;
  border: 1px solid #ccd7e6;
  min-height: 4.5rem;
  width: 100%;
}

.dt {
  outline: none;
  color: #878585;
  padding-left: 12px;
  border: 1px solid #ccd7e6;
  min-height: 4.5rem;
  width: 100%;
}

.rsis-image {
  background-position: center;
}

.react-datepicker {
  font-size: 1.3rem !important;
}

.react-datepicker__current-month {
  font-size: 1.5rem !important;
}

.react-datepicker__header {
  padding-top: 6px !important;
}

.react-datepicker__day-name,
.react-datepicker__day {
  margin: 0.5rem !important;
}

.react-datepicker__time-container {
  width: unset !important;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: unset !important;
}

.w-100 {
  width: 100%;
}

.navbar {
  max-width: 133rem;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2.7rem 2rem;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  z-index: 999;
  margin: 0 auto;
}
.navbar__img {
  width: 16.5rem;
}
.navbar__img img {
  width: 100%;
  height: 100%;
}
.navbar__links {
  display: flex;
  list-style: none;
  gap: 2.1rem;
}
.navbar__links a {
  font-size: 1.6rem;
  font-family: "Rubik", sans-serif;
  font-weight: 500;
  color: #010103;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s;
}
.navbar__links a:hover {
  color: #f5272b;
}
@media (max-width: 1000px) {
  .navbar__links {
    display: none;
  }
}
.navbar__buttons {
  display: flex;
  gap: 2.5rem;
  font-size: 1.6rem;
  font-family: "Rubik", sans-serif;
  font-weight: 500;
  align-items: center;
}
@media (max-width: 1000px) {
  .navbar__buttons {
    display: none;
  }
}
.navbar__buttons__sign-in {
  color: #010103;
  cursor: pointer;
  transition: all 0.3s;
}
.navbar__buttons__sign-in:hover {
  color: #f5272b;
}
.navbar__buttons__register {
  background-color: #f5272b;
  color: white;
  padding: 1rem 2rem;
  border-radius: 3px;
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.35);
  transition: all 0.3s;
}
.navbar__buttons__register:hover {
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.5);
  background-color: #fa4226;
}
.navbar__buttons a {
  text-decoration: none;
}

.mobile-hamb {
  font-size: 2.8rem;
  display: flex;
  cursor: pointer;
  transition: all 0.3s;
}
.mobile-hamb:hover {
  color: #f5272b;
}
@media (min-width: 1000px) {
  .mobile-hamb {
    display: none;
  }
}

.mobile-navbar {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: -100%;
  background-color: #ffffff;
  z-index: 999999;
  justify-content: center;
  align-items: center;
  transition: all 0.5s ease-in-out;
}
.mobile-navbar__close {
  font-size: 3rem;
  position: absolute;
  top: 3.5rem;
  right: 3.5rem;
  cursor: pointer;
  transition: all 0.3s;
}
.mobile-navbar__close:hover {
  color: #f5272b;
}
.mobile-navbar__links {
  display: flex;
  flex-direction: column;
  list-style: none;
  font-size: 2.3rem;
  gap: 3rem;
  text-align: center;
}
.mobile-navbar__links li a {
  text-decoration: none;
  color: #010103;
  font-weight: 500;
  transition: all 0.3s;
}
.mobile-navbar__links li a:hover {
  color: #f5272b;
}
.mobile-navbar .sign_in {
  background-color: #fa4226;
  padding: 6px;
  color: #fff;
  font-weight: 600;
  text-decoration: none;
  border-radius: 4px;
}

.open-nav {
  left: 0;
}

.hero-section {
  width: 100%;
  background-color: #f8f8f8;
  position: relative;
  overflow: hidden;
  padding: 15rem 0px;
}
@media (max-width: 1000px) {
  .hero-section {
    padding: 12rem 0rem 6rem 0rem;
  }
}

.bg-shape {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
}
@media (max-width: 800px) {
  .bg-shape {
    display: none;
  }
}

.hero-content {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
}
@media (max-width: 800px) {
  .hero-content {
    justify-content: center;
  }
}
.hero-content__text {
  display: flex;
  flex-direction: column;
  z-index: 3;
  max-width: 50rem;
}
@media (max-width: 800px) {
  .hero-content__text {
    text-align: center;
    align-items: center;
  }
}
.hero-content__text h4 {
  font-size: 2.2rem;
  font-family: "Rubik", sans-serif;
  color: #010103;
}
.hero-content__text h1 {
  font-size: 5.2rem;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  color: #010103;
  line-height: 1.2;
  margin-top: 1rem;
  margin-bottom: 2.3rem;
}
.hero-content__text h1 span {
  color: #f5272b;
}
.hero-content__text p {
  font-size: 1.6rem;
  font-family: "Rubik", sans-serif;
  line-height: 1.6;
  color: #706f7b;
  margin-bottom: 4rem;
}
.hero-content__text__btns {
  display: flex;
  gap: 2rem;
  font-size: 1.6rem;
  font-family: "Rubik", sans-serif;
}
@media (max-width: 450px) {
  .hero-content__text__btns {
    flex-direction: column;
  }
}
.hero-content__text__btns a {
  text-decoration: none;
  color: white;
  font-weight: 700;
}
.hero-content__text__btns__book-ride {
  background-color: #f5272b;
  padding: 1.8rem 3rem;
  border-radius: 0.3rem;
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.35);
  transition: all 0.3s;
  border: 2px solid #f5272b;
}
@media (max-width: 450px) {
  .hero-content__text__btns__book-ride {
    padding: 1.8rem 8rem;
  }
}
.hero-content__text__btns__book-ride:hover {
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.6);
  background-color: #fa4226;
}
.hero-content__text__btns__learn-more {
  background-color: #010103;
  padding: 1.8rem 3rem;
  border-radius: 0.3rem;
  border: 2px solid #010103;
  transition: all 0.3s;
}
.hero-content__text__btns__learn-more:hover {
  background-color: transparent;
  color: #010103;
}
.hero-content__car-img {
  z-index: 2;
  position: absolute;
  right: 0;
  width: 60%;
}
@media (max-width: 800px) {
  .hero-content__car-img {
    display: none;
  }
}

.scroll-up {
  position: fixed;
  font-size: 2.5rem;
  color: white;
  background-color: #f5272b;
  border: 3px solid white;
  width: 2rem;
  height: 2rem;
  bottom: 5rem;
  right: 5rem;
  z-index: 20;
  display: none;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 2rem;
  cursor: pointer;
}

.show-scroll {
  display: flex;
}

.book-section {
  position: relative;
  background: linear-gradient(to bottom, #f8f8f8 20%, #ffffff 80%);
}

.book-content {
  margin: 0 auto;
  margin-bottom: 10rem;
}
.book-content__box {
  background-color: #ffffff;
  width: 100%;
  padding: 4rem 4.5rem 5rem 5.5rem;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  height: auto;
  position: relative;
  z-index: 4;
  color: white;
  border-radius: 5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  color: #010103;
}
@media (max-width: 400px) {
  .book-content__box {
    padding: 4rem 2.5rem 5rem 2.5rem;
  }
}
.book-content__box__checkbox-group {
  display: flex;
  gap: 2rem;
  width: 100%;
  margin: 4px 0px;
  justify-content: flex-end;
}
.book-content__box__checkbox-group div {
  display: flex;
  align-items: center;
}
.book-content__box__checkbox-group div p {
  color: #777777;
  font-size: 14px;
  font-weight: 500;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
@media (max-width: 400px) {
  .book-content__box__checkbox-group div p {
    font-size: 12px;
  }
}
.book-content__box h2 {
  font-size: 2.4rem;
  font-weight: 700;
}
.book-content__box .error-modal {
  color: #fe3516;
}
.book-content__box .box-form {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto auto auto;
  gap: 2rem;
}
.book-content__box .box-form b {
  color: #f5272b;
}
@media (max-width: 1000px) {
  .book-content__box .box-form {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 630px) {
  .book-content__box .box-form {
    grid-template-columns: 1fr;
  }
}
.book-content__box .box-form__car-type {
  display: flex;
  flex-direction: column;
}
.book-content__box .box-form__car-type[id="1"] {
  grid-column: 1/span 2;
}
@media (max-width: 1000px) {
  .book-content__box .box-form__car-type[id="1"] {
    grid-column: 1;
  }
}
.book-content__box .box-form__car-type:last-child {
  grid-column: 2;
}
@media (max-width: 1000px) {
  .book-content__box .box-form__car-type:last-child {
    grid-column: 1;
  }
}
.book-content__box .box-form__car-type label {
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 1.2rem;
}
.book-content__box .box-form__car-type label i {
  color: #f5272b;
}
.book-content__box .box-form__car-type select {
  font-size: 1.5rem;
  color: #ababab;
  font-family: "Rubik", sans-serif;
  border: 1px solid #ccd7e6;
  border-radius: 3px;
  font-weight: 400;
  padding: 1.2rem 1.3rem;
  outline: none;
}
.book-content__box .box-form__car-time {
  display: flex;
  flex-direction: column;
  position: relative;
}
.book-content__box .box-form__car-time label {
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 1.2rem;
}
.book-content__box .box-form__car-time label i {
  color: #f5272b;
}
.book-content__box .box-form__car-time ::-webkit-datetime-edit {
  padding: 1.3rem 1.3rem;
}
.book-content__box .box-form__car-time ::-webkit-calendar-picker-indicator {
  cursor: pointer;
  font-size: 1.6rem;
}
.book-content__box .box-form__book-button {
  width: 100%;
  align-items: center;
}
@media (max-width: 630px) {
  .book-content__box .box-form__book-button {
    margin-top: 2rem;
  }
}
.book-content__box .googlemap_input {
  font-size: 1.5rem;
  color: #ababab;
  font-family: "Rubik", sans-serif;
  border: 1px solid #ccd7e6;
  border-radius: 3px;
  font-weight: 400;
  padding: 1.2rem 1.3rem;
  outline: none;
  width: 100%;
}
.book-content__box__book-button {
  width: 100%;
  padding: 1.3rem 1.3rem;
  height: fit-content;
  align-self: self-end;
  border: none;
  font-family: "Rubik", sans-serif;
  font-size: 1.8rem;
  font-weight: 500;
  color: white;
  background-color: #f5272b;
  box-shadow: 0 10px 15px rgba(255, 83, 48, 0.35);
  cursor: pointer;
  transition: all 0.3s;
}
.book-content__box__book-button:hover {
  box-shadow: 0 10px 15px rgba(255, 83, 48, 0.55);
}

.error-message {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  padding: 1rem 1.4rem;
  margin-bottom: 1.8rem;
  margin-top: -1rem;
  border: 1px solid transparent;
  border-radius: 0.8rem;
  font-size: 1.6rem;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.error-message i {
  cursor: pointer;
}

.booking-done {
  color: #2a6817;
  background-color: #c3fabe;
  border-color: #f5c6cb;
  padding: 1rem 1.4rem;
  margin-bottom: 1.8rem;
  margin-top: -1rem;
  border: 1px solid transparent;
  border-radius: 0.8rem;
  font-size: 1.6rem;
  font-weight: 500;
  display: none;
  justify-content: space-between;
  align-items: center;
}
.booking-done i {
  cursor: pointer;
}

.active-modal {
  opacity: 1 !important;
  display: flex !important;
}

.modal-overlay {
  opacity: 0;
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 999999999;
  top: 0;
  right: 0;
}

.booking-modal {
  opacity: 0;
  display: none;
  flex-direction: column;
  position: fixed;
  overflow-x: hidden;
  overflow-y: scroll;
  z-index: 999999999999;
  top: 54%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 83rem;
  height: 100vh;
  border: 2px solid white;
  background-color: rgb(255, 255, 255);
  padding-right: 2px;
  color: #010103;
}
@media (max-width: 800px) {
  .booking-modal {
    width: 95%;
    height: 95%;
  }
}
@media (max-width: 600px) {
  .booking-modal {
    top: 50%;
  }
}
.booking-modal__title {
  display: flex;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background-color: #f5272b;
  color: white;
  align-items: center;
}
.booking-modal__title h2 {
  font-size: 2.4rem;
  text-transform: uppercase;
}
.booking-modal__title i {
  font-size: 2.5rem;
  color: rgba(255, 255, 255, 0.919);
  cursor: pointer;
  transition: all 0.2;
}
.booking-modal__title i:hover {
  color: white;
}
.booking-modal__message {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 2rem 3rem;
  background-color: #ffeae6;
}
.booking-modal__message h4 {
  font-size: 1.9rem;
  font-weight: 700;
  color: #f5272b;
}
.booking-modal__message h4 i {
  font-size: 2.5rem;
}
.booking-modal__message p {
  font-size: 1.7rem;
  color: #777777;
  font-weight: 500;
  line-height: 1.6;
}
.booking-modal__car-info {
  background-color: white;
  padding: 3rem 3rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid rgba(119, 119, 119, 0.6235294118);
}
@media (max-width: 650px) {
  .booking-modal__car-info {
    grid-template-columns: 1fr;
    text-align: center;
  }
}
.booking-modal__car-info__dates {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.booking-modal__car-info__dates h5 {
  font-size: 1.8rem;
  color: #f5272b;
}
.booking-modal__car-info__dates span {
  display: flex;
  gap: 1rem;
}
@media (max-width: 650px) {
  .booking-modal__car-info__dates span {
    grid-template-columns: 1fr;
    text-align: center;
    justify-content: center;
  }
}
.booking-modal__car-info__dates span i {
  font-size: 1.8rem;
  padding-top: 0.2rem;
  color: #777777;
}
@media (max-width: 650px) {
  .booking-modal__car-info__dates span i {
    display: none;
  }
}
.booking-modal__car-info__dates span h6 {
  font-size: 1.5rem;
  margin-bottom: 0.2rem;
}
.booking-modal__car-info__dates span p {
  font-size: 1.6rem;
  color: #777777;
}
.booking-modal__car-info__dates span span {
  color: #0075ff;
  font-size: 1.6rem;
  cursor: pointer;
  font-weight: 500;
  align-items: center;
}
.booking-modal__car-info__dates span span i {
  color: #0075ff;
}
.booking-modal__car-info__model {
  display: flex;
  flex-direction: column;
  gap: 3rem;
}
@media (max-width: 650px) {
  .booking-modal__car-info__model {
    margin-top: 3.5rem;
  }
}
.booking-modal__car-info__model h5 {
  font-size: 1.8rem;
  color: #f5272b;
}
.booking-modal__car-info__model h5 span {
  color: #010103;
}
.booking-modal__car-info__model img {
  width: 100%;
  height: auto;
}
.booking-modal__person-info {
  padding: 3rem 3rem;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.booking-modal__person-info h4 {
  font-size: 1.8rem;
  text-transform: uppercase;
  color: #f5272b;
  margin-bottom: 2rem;
}

.price_note {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  justify-content: start;
  margin-top: 1rem;
  font-size: 11px;
}

.out_of_town_note {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  margin-top: 1rem;
  font-size: 11px;
}

.input-time {
  text-align: center;
  width: 8rem;
  font-size: 14px;
  cursor: pointer;
}

.info-form {
  display: flex;
  flex-direction: column;
}
.info-form__checkbox {
  display: flex;
  gap: 1rem;
  align-items: center;
  font-size: 1.6rem;
  color: #565454;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.info-form__checkbox input {
  width: 1.6rem;
  height: 1.6rem;
}
.info-form__1col {
  grid-template-columns: 1fr !important;
}
.info-form__2col, .info-form__1col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 1rem 0;
}
@media (max-width: 650px) {
  .info-form__2col, .info-form__1col {
    grid-template-columns: 1fr;
  }
}
.info-form__2col span, .info-form__1col span {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.info-form__2col span label, .info-form__1col span label {
  font-size: 1.6rem;
  font-weight: 500;
  color: #777777;
}
.info-form__2col span label b, .info-form__1col span label b {
  color: #f5272b;
}
.info-form__2col span input,
.info-form__2col span textarea, .info-form__1col span input,
.info-form__1col span textarea {
  padding: 14px 15px;
  background-color: #dbdbdb;
  color: #555;
  font-size: 1.5rem;
  font-weight: 500;
  outline: none;
  border: none;
}
.info-form__2col span select, .info-form__1col span select {
  padding: 14px 15px;
  background-color: #dbdbdb;
  color: #555;
  font-size: 1.5rem;
  font-weight: 500;
  outline: none;
  border: none;
}
.info-form__2col span select option, .info-form__1col span select option {
  background-color: #fff;
}
.info-form__2col span p, .info-form__1col span p {
  color: #fe3516;
}

.reserve-button {
  background-color: transparent;
  margin: 0 -3rem;
  padding: 3rem;
  text-align: right;
}
@media (max-width: 650px) {
  .reserve-button {
    text-align: center;
  }
}
.reserve-button button {
  font-size: 2.4rem;
  color: white;
  font-weight: 700;
  background-color: #f5272b;
  border: 1px solid #fe3516;
  padding: 1.2rem 2rem;
  cursor: pointer;
  transition: all 0.2s;
}
.reserve-button button:hover {
  background-color: #fe3516;
}

.reserve-button__disabled {
  margin: 0 -3rem;
  padding: 3rem;
  text-align: right;
}
@media (max-width: 650px) {
  .reserve-button__disabled {
    text-align: center;
  }
}
.reserve-button__disabled button {
  font-size: 2.4rem;
  color: white;
  font-weight: 700;
  background-color: #ababab;
  border: 1px solid #ababab;
  padding: 1.2rem 2rem;
  cursor: pointer;
  transition: all 0.2s;
}

.dates-div {
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
}

.price_estimation {
  color: #f5272b;
  font-weight: 600;
}

.aditional_and_prices {
  padding: 3rem;
}

.aditional_input {
  background-color: #dbdbdb;
  color: #555;
  font-size: 1.5rem;
  font-weight: 500;
  outline: none;
  border: none;
  text-align: center;
  width: 35px;
}

.map-modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.map-modal.open {
  display: block;
}
.map-modal .modal-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 6px;
  border-radius: 6px;
  width: 600px;
}
@media (max-width: 650px) {
  .map-modal .modal-content {
    width: 90vw;
  }
}
.map-modal .map-container {
  width: 100%;
  height: 380px;
}
.map-modal .button-container {
  margin-top: 10px;
  padding: 8px 0;
  display: flex;
  gap: 12px;
}
.map-modal .button-container button {
  padding: 8px 12px;
  border: none;
  font-size: 18px;
  color: white;
  border-radius: 2px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}
@media (max-width: 650px) {
  .map-modal .button-container button {
    font-size: 16px;
  }
}
.map-modal .button-container button.save {
  background-color: #f5272b;
}
.map-modal .button-container button.close {
  background-color: #000000;
}
.map-modal .button-container button:hover {
  opacity: 0.8;
}
.map-modal .address-info {
  padding: 8px;
  background-color: #f8f8f8;
  border-radius: 2px;
  font-size: 14px;
}

.plan-section {
  background-color: #ffffff;
  padding: 5.3rem 0;
}

.plan-container {
  display: flex;
  flex-direction: column;
}
.plan-container__title {
  margin: 0 auto;
  text-align: center;
  color: #010103;
}
.plan-container__title h3 {
  font-size: 2.4rem;
  font-family: "Rubik", sans-serif;
  font-weight: 500;
}
.plan-container__title h2 {
  font-size: 4.2rem;
  font-family: "Poppins", sans-serif;
  margin: 1.3rem 0 3rem 0;
}
.plan-container__boxes {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  margin-top: 3.7rem;
  padding: 0 3rem;
}
@media (max-width: 1021px) {
  .plan-container__boxes {
    grid-template-columns: 1fr 1fr;
    row-gap: 2rem;
  }
}
@media (max-width: 800px) {
  .plan-container__boxes {
    grid-template-columns: 1fr;
    margin-top: 1rem;
  }
}
.plan-container__boxes__box {
  text-align: center;
  padding: 1rem 6rem;
}
@media (max-width: 500px) {
  .plan-container__boxes__box {
    padding: 1rem 1rem;
  }
}
.plan-container__boxes__box img {
  width: 17rem;
  height: auto;
}
.plan-container__boxes__box h3 {
  font-size: 2.4rem;
  margin-bottom: 1rem;
}
.plan-container__boxes__box p {
  font-size: 1.6rem;
  font-family: "Rubik", sans-serif;
  color: #706f7b;
  line-height: 1.43;
}

.pick-section {
  padding: 10rem 0;
}

.pick-container {
  display: flex;
  flex-direction: column;
}
.pick-container__title {
  margin: 0 auto;
  text-align: center;
  color: #010103;
  max-width: 50rem;
  margin-bottom: 5rem;
}
.pick-container__title p {
  font-size: 1.6rem;
  font-family: "Rubik", sans-serif;
  color: #706f7b;
  line-height: 1.5;
}
.pick-container__title h3 {
  font-size: 2.4rem;
  font-family: "Rubik", sans-serif;
  font-weight: 500;
}
.pick-container__title h2 {
  font-size: 4.2rem;
  font-family: "Poppins", sans-serif;
  margin: 0.5rem 0 1rem 0;
}
.pick-container__car-content {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}
@media (max-width: 1050px) {
  .pick-container__car-content {
    flex-direction: column;
    gap: 5rem;
  }
}

.pick-box {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  margin-bottom: 4px;
}
.pick-box button {
  font-size: 2rem;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  border: none;
  cursor: pointer;
  padding: 1.5rem 2.5rem;
  background-color: #e9e9e9;
  transition: all 0.2s;
  text-align: left;
}
.pick-box button:hover {
  background-color: #f5272b;
  color: white;
}

.pick-car {
  width: 50rem;
  position: relative;
}
@media (max-width: 700px) {
  .pick-car {
    width: 100%;
  }
}
.pick-car img {
  width: 100%;
  margin-top: 6rem;
}

.pick-description {
  width: 25rem;
}
.pick-description__price {
  width: 100%;
  background-color: #f5272b;
  font-size: 1.8rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  color: white;
  padding: 0.3rem 1.9rem;
}
.pick-description__price span {
  font-size: 2.5rem;
  font-weight: 700;
}
.pick-description__table {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  font-size: 1.4rem;
}
.pick-description__table__col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-align: center;
  grid-template-rows: auto;
  padding: 0.9rem 0.5rem;
  border-bottom: 2px solid #706f7b;
  border-right: 2px solid #706f7b;
  border-left: 2px solid #706f7b;
}
.pick-description__table__col span:nth-child(1) {
  border-right: 2px solid #706f7b;
}

.cta-btn {
  font-size: 2rem;
  text-transform: uppercase;
  text-decoration: none;
  font-weight: 600;
  color: white;
  font-family: "Poppins", sans-serif;
  background-color: #f5272b;
  padding: 1rem 1rem;
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 1.4rem;
  transition: all 0.3s;
  box-shadow: 6px 6px 0 #efe9e9;
}
.cta-btn:hover {
  background-color: #e9381d;
}

.box-cars {
  gap: 11rem;
  display: flex;
  justify-content: space-between;
}
@media (max-width: 1200px) {
  .box-cars {
    gap: 2rem;
  }
}
@media (max-width: 700px) {
  .box-cars {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5rem;
  }
}

.colored-button {
  background-color: #f5272b !important;
  color: white;
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid rgba(0, 0, 0, 0.2588235294);
  border-bottom-color: #ff3d00;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 40%;
  right: 43%;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.banner-section {
  width: 100%;
  height: auto;
  display: flex;
  background-color: #1b2335;
  margin: 8rem 0;
  padding: 6rem 0;
  text-align: center;
}

.banner-content {
  color: white;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  align-items: center;
}
.banner-content__text {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.banner-content__text h2 {
  font-size: 5.2rem;
  line-height: 1.3;
}
@media (max-width: 550px) {
  .banner-content__text h2 {
    font-size: 4.2rem;
  }
}
.banner-content__text p {
  font-size: 2.4rem;
}
@media (max-width: 550px) {
  .banner-content__text p {
    font-size: 2rem;
  }
}
.banner-content__text span {
  color: #f5272b;
  font-weight: 500;
}

.choose-section {
  background-color: white;
  padding: 2rem 0 10rem 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: -225px 255px;
  background-size: cover;
  background-repeat: no-repeat;
}

.choose-container {
  display: flex;
  flex-direction: column;
}
.choose-container__img {
  width: 90%;
  height: auto;
  margin: 0 auto;
}
@media (max-width: 550px) {
  .choose-container__img {
    width: 100%;
  }
}

.text-container {
  display: flex;
  justify-content: space-around;
  margin-top: 3rem;
  width: 100%;
}
@media (max-width: 1000px) {
  .text-container {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 5.5rem;
  }
}
.text-container__left {
  text-align: left;
  display: flex;
  flex-direction: column;
  max-width: 50rem;
  color: #010103;
}
@media (max-width: 1000px) {
  .text-container__left {
    align-items: center;
    text-align: center;
  }
}
.text-container__left h4 {
  font-size: 2.2rem;
  margin-bottom: 0.7rem;
  font-weight: 600;
  font-family: "Rubik", sans-serif;
}
.text-container__left h2 {
  font-size: 4.2rem;
  line-height: 1.2;
  margin-bottom: 2rem;
}
.text-container__left p {
  font-size: 1.6rem;
  font-family: "Rubik", sans-serif;
  line-height: 1.5;
  color: #706f7b;
  margin-bottom: 3.3rem;
}
.text-container__left a {
  text-decoration: none;
  color: white;
  font-weight: 700;
  background-color: #f5272b;
  padding: 1.5rem 2.5rem;
  border-radius: 0.3rem;
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.35);
  transition: all 0.3s;
  border: 2px solid #f5272b;
  font-size: 1.6rem;
  width: fit-content;
}
.text-container__left a:hover {
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.6);
  background-color: #fa4226;
}
.text-container__right {
  display: flex;
  flex-direction: column;
  gap: 4.5rem;
  max-width: 44rem;
}
.text-container__right__box {
  display: flex;
}
@media (max-width: 550px) {
  .text-container__right__box {
    flex-direction: column;
    align-items: center;
  }
}
.text-container__right__box img {
  width: 11rem;
  height: 11rem;
  margin-right: 1.1rem;
}
.text-container__right__box__text {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
}
.text-container__right__box__text h4 {
  font-size: 2.4rem;
}
.text-container__right__box__text p {
  font-size: 1.6rem;
  color: #706f7b;
  font-family: "Rubik", sans-serif;
  line-height: 1.3;
}

.testimonials-section {
  background-color: #f8f8f8;
  padding: 10rem 0;
  color: #010103;
}

.testimonials-content {
  display: flex;
  flex-direction: column;
}
.testimonials-content__title {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 5rem;
  max-width: 700px;
}
.testimonials-content__title h4 {
  font-size: 2.2rem;
  font-family: "Rubik", sans-serif;
  font-weight: 500;
}
.testimonials-content__title h2 {
  font-size: 4.2rem;
  margin-bottom: 1.4rem;
}
.testimonials-content__title p {
  font-size: 1.6rem;
  font-family: "Rubik", sans-serif;
  color: #706f7b;
  line-height: 1.4;
}

.all-testimonials {
  display: flex;
  gap: 3rem;
  width: 100%;
  justify-content: flex-start;
  padding: 3rem;
  overflow-x: scroll;
}
.all-testimonials::-webkit-scrollbar {
  height: 8px;
}
.all-testimonials::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
.all-testimonials::-webkit-scrollbar-thumb {
  background: #f5272b;
  border-radius: 10px;
}
.all-testimonials__box {
  background-color: white;
  box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.08);
  width: 30%;
  padding: 2rem;
  position: relative;
  flex-shrink: 0;
  scroll-snap-align: center;
  border-radius: 10px;
  white-space: normal;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 1000px) {
  .all-testimonials__box {
    width: 90%;
    padding: 4rem;
  }
}
.all-testimonials__box p {
  font-size: 1.5rem;
  font-weight: 500;
  max-height: 250px;
  overflow-y: auto;
}
.all-testimonials__box .rating {
  color: #ffcc00;
  display: flex;
  gap: 2px;
  margin-bottom: 1.5rem;
  justify-content: space-between;
  align-items: center;
}
.all-testimonials__box .rating i {
  font-size: 2rem;
}
.all-testimonials__box .rating .left {
  display: flex;
  align-items: center;
}
.all-testimonials__box .rating .left p {
  color: #010103;
  margin-right: 1rem;
}
.all-testimonials__box .rating img {
  width: 2rem;
  height: auto;
}
.all-testimonials__box__name {
  display: flex;
}
.all-testimonials__box__name__profile {
  display: flex;
  gap: 2rem;
  align-items: center;
  margin-top: 3rem;
}
.all-testimonials__box__name__profile img {
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
}
.all-testimonials__box__name__profile h4 {
  font-size: 1.8rem;
}
.all-testimonials__box__name__profile p {
  font-size: 1.6rem;
  font-family: "Rubik", sans-serif;
  font-weight: 400;
}

.quotes-icon {
  font-size: 6.2rem;
  color: #f5272b;
  position: absolute;
  bottom: 33px;
  right: 60px;
}
@media (max-width: 470px) {
  .quotes-icon {
    display: none;
  }
}

@media (max-width: 600px) {
  .testimonials-section {
    padding: 5rem 0;
  }
  .all-testimonials {
    padding: 0rem;
  }
  .all-testimonials__box {
    width: 85%;
    padding: 3rem;
  }
}
.footer {
  background-color: white;
  width: fit-content;
  margin: auto;
  padding: 3rem 5rem;
  margin-top: 3rem;
  border-radius: 1rem;
  text-align: center;
}
.footer .google {
  display: flex;
  align-items: center;
}
.footer .google img {
  width: 3rem;
  height: auto;
  margin-right: 1rem;
}
.footer .google p {
  font-size: 2rem;
  font-weight: 700;
  color: #010103;
}
.footer .rating {
  display: flex;
  align-items: center;
  gap: 4px;
}
.footer .rating span {
  font-size: 1.5rem;
}
.footer .rating i {
  color: #ffcc00;
  font-size: 1.5rem;
}
.footer .rating {
  margin-bottom: 8px;
  margin-top: 4px;
}

.all-testimonials::-webkit-scrollbar {
  display: none;
}

.all-testimonials {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.faq-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  padding: 10rem 0;
  background-size: auto;
  background-repeat: no-repeat;
  background-position: 0 70%;
}

.faq-content {
  display: flex;
  flex-direction: column;
  color: #010103;
}
.faq-content__title {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  text-align: center;
  max-width: 80rem;
  line-height: 1.5;
}
.faq-content__title h5 {
  font-size: 2.2rem;
}
.faq-content__title h2 {
  font-size: 4.2rem;
  margin-bottom: 1.7rem;
}
.faq-content__title p {
  font-size: 1.6rem;
  color: #706f7b;
}

.all-questions {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 7rem;
}

.faq-box {
  display: flex;
  flex-direction: column;
  color: #010103;
  background-color: white;
  box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.1);
  width: 80rem;
  cursor: pointer;
}
@media (max-width: 850px) {
  .faq-box {
    width: 100%;
  }
}
.faq-box__question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
  padding: 1.8rem 4.5rem;
  transition: 0.15s ease;
}
.faq-box__question p {
  font-size: 1.8rem;
  font-weight: 500;
}
.faq-box__question i {
  font-size: 2rem;
}
.faq-box__answer {
  font-size: 1.6rem;
  font-family: "Rubik", sans-serif;
  color: #706f7b;
  line-height: 1.7;
  max-height: 0;
  overflow: hidden;
  transition: 0.4s ease;
  padding: 0 4.5rem;
}

.active-answer {
  max-height: 20rem;
  padding: 2.8rem 4.5rem;
  transition: 0.4s ease;
}
@media (max-width: 550px) {
  .active-answer {
    max-height: 30rem;
  }
}
@media (max-width: 420px) {
  .active-answer {
    max-height: 55rem;
  }
}

.active-question {
  background-color: #f5272b;
  color: white;
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.35);
}

.download-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-color: #f8f8f8;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: auto;
  padding: 10rem 0;
}
@media (max-width: 700px) {
  .download-section {
    background-image: none;
  }
}

.download-text {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 55rem;
  text-align: left;
}
@media (max-width: 700px) {
  .download-text {
    text-align: center;
    margin: 0 auto;
  }
}
.download-text h2 {
  font-size: 4.2rem;
  color: #010103;
}
.download-text p {
  font-size: 1.6rem;
  color: #706f7b;
  font-family: "Rubik", sans-serif;
  line-height: 1.5;
}
.download-text__btns {
  display: flex;
  gap: 3rem;
  margin-top: 2rem;
}
@media (max-width: 700px) {
  .download-text__btns {
    justify-content: center;
  }
}
@media (max-width: 550px) {
  .download-text__btns {
    flex-direction: column;
    align-items: center;
  }
}
.download-text__btns img {
  width: 40%;
  cursor: pointer;
}
@media (max-width: 550px) {
  .download-text__btns img {
    width: 22rem;
  }
}

footer {
  background-color: #ffffff;
  padding: 10rem 0;
}

.footer-content {
  display: grid;
  grid-template-columns: 40fr 30fr 30fr;
  gap: 8rem;
  justify-content: center;
  text-align: left;
  color: #010103;
}
@media (max-width: 1100px) {
  .footer-content {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 650px) {
  .footer-content {
    grid-template-columns: 1fr;
  }
}
.footer-content__1 {
  list-style: none;
}
@media (max-width: 650px) {
  .footer-content__1 {
    text-align: center;
  }
}
.footer-content__1 li a {
  text-decoration: none;
  color: #010103;
  transition: all 0.2s;
}
.footer-content__1 li a:hover {
  color: #f5272b;
}
.footer-content__1 li:nth-child(1) {
  font-size: 2.4rem;
  margin-bottom: 1.5rem;
}
.footer-content__1 li:nth-child(1) span {
  font-weight: 700;
}
.footer-content__1 li:nth-child(2) {
  font-size: 1.6rem;
  color: #706f7b;
  line-height: 1.7;
  margin-bottom: 3rem;
}
.footer-content__1 li:nth-child(3), .footer-content__1 li:nth-child(4), .footer-content__1 li:nth-child(5) {
  font-size: 1.6rem;
  font-family: "Rubik", sans-serif;
  font-weight: 500;
  margin-bottom: 1rem;
}
.footer-content__2 {
  list-style: none;
}
@media (max-width: 650px) {
  .footer-content__2 {
    text-align: center;
  }
}
.footer-content__2 a {
  text-decoration: none;
  color: #010103;
  transition: all 0.2s;
}
.footer-content__2 a:hover {
  color: #f5272b;
}
.footer-content__2 li {
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.footer-content__2 li:nth-child(1) {
  font-size: 2.4rem;
  font-weight: 700;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  cursor: auto;
}
.footer-content__2 input {
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 26px;
  background-color: #ececec;
  border-width: 1px;
  border-color: transparent;
  padding: 10px 60px;
  outline: none;
  margin-top: 1rem;
}
@media (max-width: 1100px) {
  .footer-content__2 input {
    width: 100%;
  }
}

.submit-email {
  text-decoration: none;
  color: white;
  font-weight: 700;
  background-color: #f5272b;
  padding: 1.5rem 2.5rem;
  border-radius: 0.3rem;
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.25);
  transition: all 0.3s;
  border: 2px solid #f5272b;
  font-size: 1.6rem;
  width: fit-content;
  cursor: pointer;
  width: 100%;
}
.submit-email:hover {
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.4);
  background-color: #fa4226;
}

.hero-pages {
  width: 100%;
  height: 41rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
.hero-pages__overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.92);
}
.hero-pages__text {
  display: flex;
  flex-direction: column;
  z-index: 3;
  position: relative;
  width: 100%;
  height: 41rem;
  justify-content: center;
  color: #010103;
}
.hero-pages__text h3 {
  font-size: 3.6rem;
  margin-bottom: 0.5rem;
}
.hero-pages__text p {
  font-size: 1.6rem;
  font-weight: 600;
}
.hero-pages__text p a {
  color: #010103;
  text-decoration: none;
  transition: all 0.2s;
}
.hero-pages__text p a:hover {
  color: #f5272b;
}

.about-main {
  margin: 10rem auto;
  display: flex;
  gap: 5rem;
  max-width: 90rem;
  align-items: center;
}
@media (max-width: 960px) {
  .about-main {
    display: grid;
    grid-template-columns: 1fr;
    text-align: center;
    max-width: 49rem;
  }
}
@media (max-width: 520px) {
  .about-main {
    max-width: 100%;
  }
}
.about-main__img {
  width: 43rem;
  height: 43rem;
}
@media (max-width: 960px) {
  .about-main__img {
    margin: 0 auto;
  }
}
@media (max-width: 520px) {
  .about-main__img {
    width: 100%;
    height: auto;
  }
}
.about-main__text {
  color: #010103;
  display: flex;
  flex-direction: column;
}
.about-main__text h3 {
  font-size: 2.2rem;
  font-family: "Rubik", sans-serif;
  font-weight: 500;
  margin-bottom: 1rem;
}
.about-main__text h2 {
  font-size: 4.2rem;
  line-height: 1.2;
}
.about-main__text p {
  font-size: 1.6rem;
  color: #706f7b;
  font-family: "Rubik", sans-serif;
  line-height: 1.5;
  margin-top: 2rem;
  margin-bottom: 4rem;
}
.about-main__text__icons {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 4rem;
}
@media (max-width: 520px) {
  .about-main__text__icons {
    grid-template-columns: 1fr;
    margin: 0 auto;
    gap: 0;
  }
  .about-main__text__icons p {
    margin-top: 0;
  }
}
.about-main__text__icons__box {
  display: flex;
  flex-direction: column;
}
@media (max-width: 520px) {
  .about-main__text__icons__box {
    align-items: center;
  }
}
.about-main__text__icons__box .last-fk {
  width: 5rem;
}
.about-main__text__icons__box img {
  width: 7rem;
}
.about-main__text__icons__box span {
  display: flex;
  align-items: center;
  gap: 1rem;
}
@media (max-width: 520px) {
  .about-main__text__icons__box span {
    text-align: center;
    flex-direction: column;
  }
}
.about-main__text__icons__box span h4 {
  font-size: 4.6rem;
}

.close-icon {
  background-color: white;
  padding: 8px;
  border: 1px solid #706f7b;
  color: #010103;
}

.book-banner {
  display: flex;
  width: 100%;
  height: 20rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  position: relative;
  margin-top: 7rem;
}
@media (max-width: 750px) {
  .book-banner {
    height: fit-content;
    padding: 1rem 0;
  }
}
.book-banner__overlay {
  background-color: #1b2335;
  opacity: 0.89;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
}

.text-content {
  color: white;
  z-index: 5;
  position: relative;
  width: 100%;
  height: 20rem;
  display: flex;
  align-items: center;
  gap: 5rem;
}
@media (max-width: 750px) {
  .text-content {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    text-align: center;
  }
}
.text-content h2 {
  font-size: 3.2rem;
}
.text-content span {
  display: flex;
  font-size: 2.7rem;
  gap: 1rem;
  align-items: center;
  color: #f5272b;
  white-space: nowrap;
}

.about-company-section {
  margin: 8rem auto 0 auto;
  padding-bottom: 6rem;
  max-width: 80rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #010103;
}
.about-company-section__logo {
  width: 36rem;
  margin-bottom: 8rem;
}
@media (max-width: 520px) {
  .about-company-section__logo {
    width: 18rem;
    margin-bottom: 4rem;
  }
}
.about-company-section__subtitle {
  font-size: 2.2rem;
  font-family: "Rubik", sans-serif;
  font-weight: 500;
  margin-bottom: 1rem;
}
.about-company-section__title {
  font-size: 4.2rem;
  line-height: 1.2;
  margin-bottom: 2rem;
}
.about-company-section__description {
  font-size: 1.6rem;
  color: #706f7b;
  font-family: "Rubik", sans-serif;
  line-height: 1.6;
}

.models-div {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  gap: 3rem;
  align-items: center;
  text-align: center;
  padding: 10rem 0;
  width: 110rem;
  margin: 0 auto;
}
@media (max-width: 1150px) {
  .models-div {
    grid-template-columns: 1fr 1fr;
    width: fit-content;
  }
}
@media (max-width: 800px) {
  .models-div {
    grid-template-columns: 1fr;
    width: fit-content;
  }
}
.models-div__box {
  border: 1px solid #d5d5d5;
  border-radius: 0.3rem;
  display: flex;
  width: 35rem;
  flex-direction: column;
  justify-content: end;
  height: 58rem;
}
@media (max-width: 400px) {
  .models-div__box {
    grid-template-columns: 1fr;
    width: 100%;
  }
}
.models-div__box__img {
  border-radius: 0.3rem;
  overflow: hidden;
}
.models-div__box__img img {
  display: block;
  width: 100%;
  max-height: 24rem;
  object-fit: cover;
}
.models-div__box__descr {
  padding: 3rem 3rem;
  display: flex;
  flex-direction: column;
  color: #010103;
}
.models-div__box__descr__name-price {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.models-div__box__descr__name-price__name {
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 0.5rem;
}
.models-div__box__descr__name-price__name p {
  font-size: 2.4rem;
  font-weight: 700;
}
.models-div__box__descr__name-price__name span {
  display: flex;
  gap: 0.4rem;
}
.models-div__box__descr__name-price__name span i {
  font-size: 1.4rem;
  color: #ffc933;
}
.models-div__box__descr__name-price__price {
  display: flex;
  flex-direction: row;
  text-align: right;
}
.models-div__box__descr__name-price__price h4 {
  font-size: 2.8rem;
}
.models-div__box__descr__name-price__price p {
  font-size: 1.6rem;
}
.models-div__box__descr__name-price__price i {
  font-size: 1.4rem;
  color: #ffc933;
}
.models-div__box__descr__name-price__details {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
  gap: 6px;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
  border-bottom: 1px solid #c6c6c6;
  align-items: center;
  height: 8.5rem;
}
.models-div__box__descr__name-price__details__self-prices {
  width: 50%;
  display: flex;
  flex-direction: column;
  text-align: start;
}
.models-div__box__descr__name-price__details__self-prices p {
  color: grey;
  font-size: 12px;
}
.models-div__box__descr__name-price__details__self-prices span {
  font-size: 20px;
  font-weight: 700;
  color: #f5272b;
}
.models-div__box__descr__name-price__details__includes {
  text-align: start;
  width: 50%;
}
.models-div__box__descr__name-price__details__includes div span {
  color: #010103;
  font-weight: 600;
  font-size: 12px;
}
.models-div__box__descr__name-price__details__includes p {
  color: grey;
}
.models-div__box__descr__name-price__btn {
  background-color: #f5272b;
  padding: 1.8rem 3rem;
  border-radius: 0.3rem;
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.35);
  transition: all 0.3s;
  border: 2px solid #f5272b;
  font-size: 1.8rem;
  cursor: pointer;
}
.models-div__box__descr__name-price__btn:hover {
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.6);
  background-color: #fa4226;
}
.models-div__box__descr__name-price__btn a {
  text-decoration: none;
  color: white;
  font-weight: 700;
}
.models-div__box__descr__name-price__h2 {
  color: #ccc;
  margin-top: 8;
  font-weight: 600;
  height: 65px;
}
.models-div__box__descr__specification {
  display: flex;
  gap: 2rem;
  padding: 1rem;
  justify-content: space-between;
  margin-top: -12px;
}
.models-div__box__descr__specification i {
  font-size: 1.5rem;
}

.dialog_modal {
  text-align: center;
  border-radius: 18px;
  padding: 3rem;
}
.dialog_modal h2 {
  color: #13c39c;
  font-size: 2.5rem;
  margin-top: 2rem;
  font-weight: 600;
}
.dialog_modal p {
  color: #ababab;
  margin-top: 0.5rem;
  margin-bottom: 4rem;
  max-width: 312px;
  font-size: 12px;
}
.dialog_modal button {
  border: none;
  background-color: #13c39c;
  color: #fff;
  padding: 10px 24px;
  border-radius: 4px;
  font-weight: 600;
}

.team-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  gap: 4rem;
  align-items: center;
  text-align: center;
  padding: 10rem 2rem;
  width: 110rem;
  margin: 0 auto;
}
@media (max-width: 1150px) {
  .team-container {
    grid-template-columns: 1fr 1fr;
    width: fit-content;
  }
}
@media (max-width: 800px) {
  .team-container {
    grid-template-columns: 1fr;
    width: fit-content;
  }
}
.team-container__box {
  width: 33rem;
  background-color: white;
  box-shadow: 0px 20px 10px 0px rgba(0, 0, 0, 0.08);
}
@media (max-width: 400px) {
  .team-container__box {
    width: 100%;
  }
}
.team-container__box__img-div {
  width: 100%;
  height: auto;
  background-color: #f6f6f6;
}
.team-container__box__img-div img {
  width: 100%;
}
.team-container__box__descr {
  color: #010103;
  padding: 3rem;
}
.team-container__box__descr h3 {
  font-size: 2.2rem;
}
.team-container__box__descr p {
  font-size: 1.6rem;
  font-weight: 500;
  color: #777777;
}

.contact-div {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  margin: 0 auto;
  color: #010103;
  padding: 10rem 2rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: auto;
  background-position: center center;
  background-repeat: no-repeat;
}
@media (max-width: 950px) {
  .contact-div {
    grid-template-columns: 1fr;
    text-align: center;
  }
}
.contact-div__text {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 41rem;
}
@media (max-width: 950px) {
  .contact-div__text {
    margin: 0 auto;
    margin-bottom: 2rem;
  }
}
.contact-div__text h2 {
  font-size: 4.2rem;
  line-height: 1.3;
  margin-bottom: 2rem;
}
.contact-div__text p {
  font-size: 1.6rem;
  font-family: "Rubik", sans-serif;
  color: #706f7b;
  line-height: 1.6;
  margin-bottom: 2rem;
}
.contact-div__text a {
  text-decoration: none;
  color: #010103;
  font-size: 1.6rem;
  font-weight: 500;
  transition: all 0.2s;
  margin-bottom: 0.5rem;
}
.contact-div__text a:hover {
  color: #f5272b;
}
.contact-div__form {
  display: flex;
  flex-direction: column;
}
.contact-div__form form {
  display: flex;
  flex-direction: column;
}
.contact-div__form form label {
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 1rem;
}
.contact-div__form form label b {
  color: #f5272b;
}
.contact-div__form form input {
  background-color: #f2f2f2;
  padding: 19px 30px 19px 30px;
  font-size: 1.6rem;
  border: none;
  outline: none;
  margin-bottom: 2.3rem;
}
.contact-div__form form textarea {
  background-color: #f2f2f2;
  height: 18rem;
  padding: 19px 30px 19px 30px;
  font-size: 1.6rem;
  border: none;
  outline: none;
  margin-bottom: 2.5rem;
}
.contact-div__form form button {
  background-color: #f5272b;
  padding: 1.8rem 3rem;
  border-radius: 0.3rem;
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.35);
  transition: all 0.3s;
  border: 2px solid #f5272b;
  color: white;
  font-size: 1.8rem;
  font-weight: 600;
  cursor: pointer;
}
.contact-div__form form button:hover {
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.6);
  background-color: #fa4226;
}

.estimate-section {
  padding: 10rem 0;
}

.estimate-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.estimate-car {
  width: 50rem;
  position: relative;
}
@media (max-width: 700px) {
  .estimate-car {
    width: 100%;
  }
}

.estimate-description {
  width: 100%;
}
.estimate-description__price {
  width: 100%;
  background-color: #f5272b;
  font-size: 1.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  padding: 0.3rem 1.9rem;
  white-space: nowrap;
}
.estimate-description__price span {
  font-size: 2.5rem;
  font-weight: 700;
}
.estimate-description__table {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  font-size: 1.4rem;
}
.estimate-description__table__col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-align: center;
  grid-template-rows: auto;
  padding: 0.9rem 0.5rem;
  border-bottom: 2px solid #706f7b;
  border-right: 2px solid #706f7b;
  border-left: 2px solid #706f7b;
}
.estimate-description__table__col span:nth-child(1) {
  border-right: 2px solid #706f7b;
}
.estimate-description__table__col h4:nth-child(1) {
  border-right: 2px solid #706f7b;
}

.detail-section {
  padding: 10rem;
}
@media (max-width: 1150px) {
  .detail-section {
    padding: 6rem;
  }
}
@media (max-width: 800px) {
  .detail-section {
    padding: 1rem;
  }
}
.detail-section__btn {
  background-color: #f5272b;
  padding: 1rem 4rem;
  border-radius: 0.3rem;
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.35);
  transition: all 0.3s;
  border: 2px solid #f5272b;
  font-size: 1.4rem;
  cursor: pointer;
  text-align: center;
}
.detail-section__btn:hover {
  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.6);
  background-color: #fa4226;
}
.detail-section__btn a {
  text-decoration: none;
  color: white;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/_boilerplate.scss","webpack://./src/styles/styles.scss","webpack://./src/styles/global/_colors.scss","webpack://./src/styles/global/_typhography.scss","webpack://./src/styles/NavbarStyles/_navbar.scss","webpack://./src/styles/HeroStyles/_hero.scss","webpack://./src/styles/BookStyles/_book.scss","webpack://./src/styles/PlanTripStyles/_plan.scss","webpack://./src/styles/PickStyles/_pick.scss","webpack://./src/styles/BannerStyles/_banner.scss","webpack://./src/styles/ChooseStyles/_choose.scss","webpack://./src/styles/TestimonialsStyles/_testimonials.scss","webpack://./src/styles/FaqStyles/_faq.scss","webpack://./src/styles/DownloadStyles/_download.scss","webpack://./src/styles/FooterStyles/_footer.scss","webpack://./src/styles/AboutStyles/_about.scss","webpack://./src/styles/ModelsStyles/_models.scss","webpack://./src/styles/TeamStyles/_team.scss","webpack://./src/styles/ContactStyles/_contact.scss","webpack://./src/styles/PriceEstimateStyles/_estimate.scss","webpack://./src/styles/DetailStyles/_detail.scss"],"names":[],"mappings":"AAGA;EACE,sBAAA;EACA,SAAA;EACA,UAAA;ACFF;;ADKA;EACE,gBAAA;EACA,uBAAA;ACFF;;ADKA;EACE,yBEbS;EFcT,kCGfY;EHgBZ,kBAAA;ACFF;;ADKA;EACE,4BAAA;EACA,yBAAA;EACA,4BAAA;ACFF;;ADOA,YAAA;AACA;EACE,qBAAA;EACA,gCAAA;ACJF;;ADOA,4BAAA;AACA;EAEE,WAAA;ACJF;;ADMA;EACE,kBAAA;EACA,yBAAA;ACHF;;ADMA;EACE,yBAAA;ACHF;;ADMA;EACE,yBAAA;ACHF;;ADMA;EACE,mBAAA;EACA,yBAAA;ACHF;;ADMA;EACE,yBAAA;ACHF;;ADMA;EACE,yBAAA;ACHF;;ADMA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ACHF;;ADMA;EAEE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;ACHF;ADIE;EACE,YAAA;ACFJ;;ADMA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;ACHF;ADIE;EACE,YAAA;ACFJ;;ADMA;EACE,aAAA;EACA,oBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,2BAAA;EACA,gCAAA;EACA,2CAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,0CAAA;EAEA,4GAAA;ACJF;ADKE;EACE,aAAA;EACA,2CAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;ACHJ;;ADYA;EACE,MAAA;ACTF;;ADYA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;ACTF;;ADYA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;ACTF;;ADYA;EACE,2BAAA;ACTF;;ADYA;EACE,4BAAA;ACTF;;ADYA;EACE,4BAAA;ACTF;;ADYA;EACE,2BAAA;ACTF;;ADYA;;EAEE,yBAAA;ACTF;;ADYA;EACE,uBAAA;ACTF;ADUE;EACE,uBAAA;ACRJ;;ADYA;EACE,WAAA;ACTF;;AGlLA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,6BAAA;EACA,YAAA;EACA,cAAA;AHqLF;AGnLE;EACE,cAAA;AHqLJ;AGpLI;EACE,WAAA;EACA,YAAA;AHsLN;AGlLE;EACE,aAAA;EACA,gBAAA;EACA,WAAA;AHoLJ;AGlLI;EACE,iBDvBG;ECwBH,gCD/BM;ECgCN,gBAAA;EACA,cF9BO;EE+BP,qBAAA;EACA,eAAA;EACA,oBAAA;AHoLN;AGlLM;EACE,cFnCM;ADuNd;AGhLI;EAnBF;IAoBI,aAAA;EHmLJ;AACF;AGhLE;EACE,aAAA;EACA,WAAA;EACA,iBD5CK;EC6CL,gCDpDQ;ECqDR,gBAAA;EACA,mBAAA;AHkLJ;AGhLI;EARF;IASI,aAAA;EHmLJ;AACF;AGjLI;EACE,cF1DO;EE2DP,eAAA;EACA,oBAAA;AHmLN;AGjLM;EACE,cF9DM;ADiPd;AG/KI;EACE,yBFnEQ;EEoER,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iDAAA;EACA,oBAAA;AHiLN;AG/KM;EACE,gDAAA;EACA,yBAAA;AHiLR;AG7KI;EACE,qBAAA;AH+KN;;AGxKA;EACE,iBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;AH2KF;AGzKE;EACE,cF/FU;AD0Qd;AGxKE;EAVF;IAWI,aAAA;EH2KF;AACF;;AGxKA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,yBFnHS;EEoHT,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;AH2KF;AGzKE;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;AH2KJ;AGzKI;EACE,cF9HQ;ADySd;AGvKE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;AHyKJ;AGtKM;EACE,qBAAA;EACA,cF9IK;EE+IL,gBAAA;EACA,oBAAA;AHwKR;AGtKQ;EACE,cFlJI;AD0Td;AGnKE;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AHqKJ;;AGjKA;EACE,OAAA;AHoKF;;AI1UA;EACE,WAAA;EACA,yBHHQ;EGIR,kBAAA;EACA,gBAAA;EACA,kBAAA;AJ6UF;AI3UE;EAPF;IAQI,6BAAA;EJ8UF;AACF;;AI3UA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;AJ8UF;AI5UE;EANF;IAOI,aAAA;EJ+UF;AACF;;AI5UA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AJ+UF;AI7UE;EANF;IAOI,uBAAA;EJgVF;AACF;AI9UE;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;AJgVJ;AI9UI;EANF;IAOI,kBAAA;IACA,mBAAA;EJiVJ;AACF;AI/UI;EACE,iBFvCI;EEwCJ,gCF9CM;EE+CN,cH5CO;AD6Xb;AI9UI;EACE,iBFhDI;EEiDJ,kCFrDQ;EEsDR,gBAAA;EACA,cHnDO;EGoDP,gBAAA;EACA,gBAAA;EACA,qBAAA;AJgVN;AI9UM;EACE,cHxDM;ADwYd;AI5UI;EACE,iBF1DG;EE2DH,gCFlEM;EEmEN,gBAAA;EACA,cH9DM;EG+DN,mBAAA;AJ8UN;AI3UI;EACE,aAAA;EACA,SAAA;EACA,iBFpEG;EEqEH,gCF5EM;AFyZZ;AI3UM;EANF;IAOI,sBAAA;EJ8UN;AACF;AI5UM;EACE,qBAAA;EACA,YAAA;EACA,gBAAA;AJ8UR;AI3UM;EACE,yBHrFM;EGsFN,oBAAA;EACA,qBAAA;EACA,iDAAA;EACA,oBAAA;EACA,yBAAA;AJ6UR;AI3UQ;EARF;IASI,oBAAA;EJ8UR;AACF;AI5UQ;EACE,gDAAA;EACA,yBAAA;AJ8UV;AI1UM;EACE,yBHxGK;EGyGL,oBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;AJ4UR;AI1UQ;EACE,6BAAA;EACA,cHhHG;AD4bb;AItUE;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AJwUJ;AItUI;EANF;IAOI,aAAA;EJyUJ;AACF;;AIrUA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;EACA,yBHrIY;EGsIZ,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;AJwUF;;AIrUA;EACE,aAAA;AJwUF;;AKjeA;EACE,kBAAA;EAEA,gEAAA;ALmeF;;AKheA;EACE,cAAA;EACA,oBAAA;ALmeF;AKjeE;EACE,yBJXO;EIYP,WAAA;EACA,gCAAA;EACA,4CAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,yDAAA;EACA,kCAAA;EACA,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,cJvBS;AD0fb;AKjeI;EAlBF;IAmBI,gCAAA;ELoeJ;AACF;AKleI;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;ALoeN;AKneM;EACE,aAAA;EACA,mBAAA;ALqeR;AKneQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;ALqeV;AKpeU;EANF;IAOI,eAAA;ELueV;AACF;AKleI;EACE,iBHnDI;EGoDJ,gBAAA;ALoeN;AKheI;EACE,cAAA;ALkeN;AK/dI;EACE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,SAAA;ALieN;AK/dM;EACE,cJpEM;ADqiBd;AK9dM;EAVF;IAWI,0BAAA;ELieN;AACF;AK/dM;EAdF;IAeI,0BAAA;ELkeN;AACF;AKheM;EACE,aAAA;EACA,sBAAA;ALkeR;AKheQ;EACE,qBAAA;ALkeV;AKjeU;EAFF;IAGI,cAAA;ELoeV;AACF;AKjeQ;EACE,cAAA;ALmeV;AKleU;EAFF;IAGI,cAAA;ELqeV;AACF;AKleQ;EACE,iBH/FD;EGgGC,gBAAA;EACA,qBAAA;ALoeV;AKleU;EACE,cJvGE;AD2kBd;AKheQ;EACE,iBAAA;EACA,cAAA;EACA,gCHlHE;EGmHF,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;ALkeV;AK9dM;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;ALgeR;AKvdQ;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;ALydV;AKvdU;EACE,cJzIE;ADkmBd;AKrdQ;EACE,sBAAA;ALudV;AKpdQ;EACE,eAAA;EACA,iBAAA;ALsdV;AKldM;EACE,WAAA;EACA,mBAAA;ALodR;AKndQ;EAHF;IAII,gBAAA;ELsdR;AACF;AKldI;EACE,iBAAA;EACA,cAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;ALodN;AKjdI;EACE,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;EACA,gCHtLM;EGuLN,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBJtLQ;EIuLR,+CAAA;EACA,eAAA;EACA,oBAAA;ALmdN;AKjdM;EACE,+CAAA;ALmdR;;AK7cA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,6BAAA;EACA,qBAAA;EACA,iBHxMO;EGyMP,gBAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;AL+cF;AK7cE;EACE,eAAA;AL+cJ;;AK3cA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,6BAAA;EACA,qBAAA;EACA,iBH7NO;EG8NP,gBAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;AL6cF;AK3cE;EACE,eAAA;AL6cJ;;AKvcA;EACE,qBAAA;EACA,wBAAA;AL0cF;;AKvcA;EACE,UAAA;EACA,aAAA;EAEA,eAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;ALycF;;AKtcA;EACE,UAAA;EACA,aAAA;EAEA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,oCAAA;EACA,kBAAA;EACA,cJlRW;AD0tBb;AKtcE;EAnBF;IAoBI,UAAA;IACA,WAAA;ELycF;AACF;AKvcE;EAxBF;IAyBI,QAAA;EL0cF;AACF;AKxcE;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,yBJhSU;EIiSV,YAAA;EACA,mBAAA;AL0cJ;AKxcI;EACE,iBHpSI;EGqSJ,yBAAA;AL0cN;AKvcI;EACE,iBAAA;EACA,iCAAA;EACA,eAAA;EACA,mBAAA;ALycN;AKvcM;EACE,YAAA;ALycR;AKpcE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;ALscJ;AKpcI;EACE,iBAAA;EACA,gBAAA;EACA,cJ/TQ;ADqwBd;AKpcM;EACE,iBAAA;ALscR;AKlcI;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;ALocN;AKhcE;EACE,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,0DAAA;ALkcJ;AKhcI;EAPF;IAQI,0BAAA;IACA,kBAAA;ELmcJ;AACF;AKjcI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ALmcN;AKjcM;EACE,iBAAA;EACA,cJjWM;ADoyBd;AKhcM;EACE,aAAA;EACA,SAAA;ALkcR;AKhcQ;EAJF;IAKI,0BAAA;IACA,kBAAA;IACA,uBAAA;ELmcR;AACF;AKjcQ;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;ALmcV;AKjcU;EALF;IAMI,aAAA;ELocV;AACF;AKjcQ;EACE,iBAAA;EACA,qBAAA;ALmcV;AKhcQ;EACE,iBH3XD;EG4XC,cAAA;ALkcV;AKhcQ;EACE,cAAA;EACA,iBHhYD;EGiYC,eAAA;EACA,gBAAA;EAEA,mBAAA;ALicV;AK/bU;EACE,cAAA;ALicZ;AK3bI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AL6bN;AK3bM;EALF;IAMI,kBAAA;EL8bN;AACF;AK5bM;EACE,iBAAA;EACA,cJ3ZM;ADy1Bd;AK5bQ;EACE,cJ/ZG;AD61Bb;AK1bM;EACE,WAAA;EACA,YAAA;AL4bR;AKvbE;EACE,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;ALybJ;AKvbI;EACE,iBAAA;EACA,yBAAA;EACA,cJlbQ;EImbR,mBAAA;ALybN;;AKpbA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;ALubF;;AKpbA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;ALubF;;AKpbA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;ALubF;;AKpbA;EACE,aAAA;EACA,sBAAA;ALubF;AKrbE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,iBHvdK;EGwdL,cAAA;EACA,gBAAA;EACA,mBAAA;ALubJ;AKrbI;EACE,aAAA;EACA,cAAA;ALubN;AKnbE;EACE,qCAAA;ALqbJ;AKlbE;EAEE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;ALmbJ;AKjbI;EAPF;IAQI,0BAAA;ELobJ;AACF;AKlbI;EACE,aAAA;EACA,sBAAA;EACA,WAAA;ALobN;AKlbM;EACE,iBHvfC;EGwfD,gBAAA;EACA,cAAA;ALobR;AKlbQ;EACE,cJ/fI;ADm7Bd;AKhbM;;;EAEE,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;ALmbR;AKhbM;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;ALkbR;AKjbQ;EACE,sBAAA;ALmbV;AK/aM;EACE,cAAA;ALibR;;AK3aA;EACE,6BAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AL8aF;AK5aE;EANF;IAOI,kBAAA;EL+aF;AACF;AK7aE;EACE,iBH5iBM;EG6iBN,YAAA;EACA,gBAAA;EACA,yBJhjBU;EIijBV,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,oBAAA;AL+aJ;AK7aI;EACE,yBAAA;AL+aN;;AK1aA;EACE,eAAA;EACA,aAAA;EACA,iBAAA;AL6aF;AK3aE;EALF;IAMI,kBAAA;EL8aF;AACF;AK5aE;EACE,iBHrkBM;EGskBN,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,oBAAA;AL8aJ;;AK1aA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AL6aF;;AK1aA;EACE,cAAA;EACA,gBAAA;AL6aF;;AK1aA;EACE,aAAA;AL6aF;;AKvaA;EACE,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AL0aF;;AKvaA;EACE,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;AL0aF;AKxaE;EACE,cAAA;AL0aJ;AKvaE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;ALyaJ;AKvaI;EAVF;IAWI,WAAA;EL0aJ;AACF;AKvaE;EACE,WAAA;EACA,aAAA;ALyaJ;AKtaE;EACE,gBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;ALwaJ;AKtaI;EACE,iBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6CAAA;ALwaN;AKtaM;EATF;IAUI,eAAA;ELyaN;AACF;AKvaM;EACE,yBAAA;ALyaR;AKtaM;EACE,yBAAA;ALwaR;AKraM;EACE,YAAA;ALuaR;AKlaE;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;ALoaJ;;AM7lCA;EACE,yBLDS;EKET,iBAAA;ANgmCF;;AM7lCA;EACE,aAAA;EACA,sBAAA;ANgmCF;AM9lCE;EACE,cAAA;EACA,kBAAA;EACA,cLTS;ADymCb;AM9lCI;EACE,iBJVI;EIWJ,gCJhBM;EIiBN,gBAAA;ANgmCN;AM7lCI;EACE,iBJjBI;EIkBJ,kCJvBQ;EIwBR,uBAAA;AN+lCN;AM3lCE;EACE,aAAA;EACA,kCAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;AN6lCJ;AM3lCI;EAPF;IAQI,8BAAA;IACA,aAAA;EN8lCJ;AACF;AM5lCI;EAZF;IAaI,0BAAA;IACA,gBAAA;EN+lCJ;AACF;AM7lCI;EACE,kBAAA;EACA,kBAAA;AN+lCN;AM7lCM;EAJF;IAKI,kBAAA;ENgmCN;AACF;AM9lCM;EACE,YAAA;EACA,YAAA;ANgmCR;AM7lCM;EACE,iBJrDE;EIsDF,mBAAA;AN+lCR;AM5lCM;EACE,iBJxDC;EIyDD,gCJhEI;EIiEJ,cL3DI;EK4DJ,iBAAA;AN8lCR;;AOhqCA;EACE,gBAAA;APmqCF;;AOhqCA;EACE,aAAA;EACA,sBAAA;APmqCF;AOjqCE;EACE,cAAA;EACA,kBAAA;EACA,cNRS;EMST,gBAAA;EACA,mBAAA;APmqCJ;AOjqCI;EACE,iBLTG;EKUH,gCLjBM;EKkBN,cNZM;EMaN,gBAAA;APmqCN;AOhqCI;EACE,iBLlBI;EKmBJ,gCLxBM;EKyBN,gBAAA;APkqCN;AO/pCI;EACE,iBLzBI;EK0BJ,kCL/BQ;EKgCR,uBAAA;APiqCN;AO7pCE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AP+pCJ;AO7pCI;EALF;IAMI,sBAAA;IACA,SAAA;EPgqCJ;AACF;;AO5pCA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AP+pCF;AO7pCE;EACE,eAAA;EACA,kCLxDU;EKyDV,gBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;AP+pCJ;AO7pCI;EACE,yBN7DQ;EM8DR,YAAA;AP+pCN;;AO1pCA;EACE,YAAA;EACA,kBAAA;AP6pCF;AO3pCE;EAJF;IAKI,WAAA;EP8pCF;AACF;AO5pCE;EACE,WAAA;EACA,gBAAA;AP8pCJ;;AO1pCA;EACE,YAAA;AP6pCF;AO3pCE;EACE,WAAA;EACA,yBNtFU;EMuFV,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AP6pCJ;AO3pCI;EACE,iBAAA;EACA,gBAAA;AP6pCN;AOzpCE;EACE,aAAA;EACA,0BAAA;EACA,wBAAA;EACA,iBAAA;AP2pCJ;AOxpCI;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,wBAAA;EACA,sBAAA;EACA,gCAAA;EACA,+BAAA;EACA,8BAAA;AP0pCN;AOxpCM;EACE,+BAAA;AP0pCR;;AOppCA;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCLvIY;EKwIZ,yBNnIY;EMoIZ,kBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,6BAAA;APupCF;AOrpCE;EACE,yBAAA;APupCJ;;AOnpCA;EACE,UAAA;EACA,aAAA;EACA,8BAAA;APspCF;AOppCE;EALF;IAMI,SAAA;EPupCF;AACF;AOrpCE;EATF;IAUI,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,SAAA;EPwpCF;AACF;;AOrpCA;EACE,oCAAA;EACA,YAAA;APwpCF;;AOppCA;EACE,WAAA;EACA,YAAA;EACA,6CAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gCAAA;EACA,QAAA;EACA,UAAA;APupCF;;AOppCA;EACE;IACE,uBAAA;EPupCF;EOrpCA;IACE,yBAAA;EPupCF;AACF;AQx1CA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AR01CF;;AQv1CA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AR01CF;AQx1CE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AR01CJ;AQx1CI;EACE,iBNrBI;EMsBJ,gBAAA;AR01CN;AQx1CM;EAJF;IAKI,iBNxBE;EFm3CR;AACF;AQx1CI;EACE,iBN5BI;AFs3CV;AQx1CM;EAHF;IAII,eAAA;ER21CN;AACF;AQx1CI;EACE,cPrCQ;EOsCR,gBAAA;AR01CN;;ASp4CA;EACE,uBAAA;EACA,uBAAA;EACA,yDAAA;EACA,iCAAA;EACA,sBAAA;EACA,4BAAA;ATu4CF;;ASp4CA;EACE,aAAA;EACA,sBAAA;ATu4CF;ASr4CE;EACE,UAAA;EACA,YAAA;EACA,cAAA;ATu4CJ;ASr4CI;EALF;IAMI,WAAA;ETw4CJ;AACF;;ASp4CA;EACE,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,WAAA;ATu4CF;ASr4CE;EANF;IAOI,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,WAAA;ETw4CF;AACF;ASt4CE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,cRvCS;AD+6Cb;ASt4CI;EAPF;IAQI,mBAAA;IACA,kBAAA;ETy4CJ;AACF;ASv4CI;EACE,iBP5CI;EO6CJ,qBAAA;EACA,gBAAA;EACA,gCPrDM;AF87CZ;ASt4CI;EACE,iBPrDI;EOsDJ,gBAAA;EACA,mBAAA;ATw4CN;ASr4CI;EACE,iBPxDG;EOyDH,gCPhEM;EOiEN,gBAAA;EACA,cR5DM;EQ6DN,qBAAA;ATu4CN;ASp4CI;EACE,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iDAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBPzEG;EO0EH,kBAAA;ATs4CN;ASp4CM;EACE,gDAAA;EACA,yBAAA;ATs4CR;ASj4CE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;ATm4CJ;ASj4CI;EACE,aAAA;ATm4CN;ASj4CM;EAHF;IAII,sBAAA;IACA,mBAAA;ETo4CN;AACF;ASl4CM;EACE,YAAA;EACA,aAAA;EACA,oBAAA;ATo4CR;ASj4CM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;ATm4CR;ASj4CQ;EACE,iBPhHA;AFm/CV;ASh4CQ;EACE,iBPlHD;EOmHC,cRpHE;EQqHF,gCP3HE;EO4HF,gBAAA;ATk4CV;;AU9/CA;EACE,yBTFQ;ESGR,gBAAA;EACA,cAAA;AVigDF;;AU9/CA;EACE,aAAA;EACA,sBAAA;AVigDF;AU//CE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AVigDJ;AU//CI;EACE,iBRbI;EQcJ,gCRpBM;EQqBN,gBAAA;AVigDN;AU9/CI;EACE,iBRrBI;EQsBJ,qBAAA;AVggDN;AU7/CI;EACE,iBRvBG;EQwBH,gCR/BM;EQgCN,cT1BM;ES2BN,gBAAA;AV+/CN;;AU1/CA;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,aAAA;EACA,kBAAA;AV6/CF;AU3/CE;EACE,WAAA;AV6/CJ;AU1/CE;EACE,mBAAA;EACA,mBAAA;AV4/CJ;AUz/CE;EACE,mBTpDU;ESqDV,mBAAA;AV2/CJ;AUx/CE;EACE,uBAAA;EACA,6CAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AV0/CJ;AUx/CI;EAdF;IAeI,UAAA;IACA,aAAA;EV2/CJ;AACF;AUz/CI;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AV2/CN;AUx/CI;EACE,cAAA;EACA,aAAA;EACA,QAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;AV0/CN;AUx/CM;EACE,eAAA;AV0/CR;AUx/CM;EACE,aAAA;EACA,mBAAA;AV0/CR;AUz/CQ;EACE,cTlGG;ESmGH,kBAAA;AV2/CV;AUx/CM;EACE,WAAA;EACA,YAAA;AV0/CR;AUt/CI;EACE,aAAA;AVw/CN;AUt/CM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AVw/CR;AUt/CQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AVw/CV;AUr/CQ;EACE,iBAAA;AVu/CV;AUp/CQ;EACE,iBR5HD;EQ6HC,gCRpIE;EQqIF,gBAAA;AVs/CV;;AU/+CA;EACE,iBAAA;EACA,cT1IY;ES2IZ,kBAAA;EACA,YAAA;EACA,WAAA;AVk/CF;AUh/CE;EAPF;IAQI,aAAA;EVm/CF;AACF;;AUh/CA;EACE;IACE,eAAA;EVm/CF;EUh/CA;IACE,aAAA;EVk/CF;EU/+CA;IACE,UAAA;IACA,aAAA;EVi/CF;AACF;AU9+CA;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AVg/CF;AU9+CE;EACE,aAAA;EACA,mBAAA;AVg/CJ;AU9+CI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AVg/CN;AU7+CI;EACE,eAAA;EACA,gBAAA;EACA,cT1LO;ADyqDb;AU5+CE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AV8+CJ;AU7+CI;EACE,iBAAA;AV++CN;AU7+CI;EACE,cAAA;EACA,iBAAA;AV++CN;AUx/CE;EAWE,kBAAA;EACA,eAAA;AVg/CJ;;AU5+CA;EACE,aAAA;AV++CF;;AU5+CA;EACE,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AV++CF;;AWrsDA;EACE,yDAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,0BAAA;AXwsDF;;AWrsDA;EACE,aAAA;EACA,sBAAA;EACA,cVRW;ADgtDb;AWtsDE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AXwsDJ;AWtsDI;EACE,iBThBI;AFwtDV;AWrsDI;EACE,iBTtBI;ESuBJ,qBAAA;AXusDN;AWpsDI;EACE,iBTxBG;ESyBH,cV1BM;ADguDZ;;AWjsDA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AXosDF;;AWjsDA;EACE,aAAA;EACA,sBAAA;EACA,cV5CW;EU6CX,uBAAA;EACA,4CAAA;EAEA,YAAA;EACA,eAAA;AXmsDF;AWjsDE;EAVF;IAWI,WAAA;EXosDF;AACF;AWlsDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,0CAAA;EACA,sBAAA;EACA,sBAAA;AXosDJ;AWlsDI;EACE,iBAAA;EACA,gBAAA;AXosDN;AWjsDI;EACE,eAAA;AXmsDN;AW/rDE;EACE,iBTtEK;ESuEL,gCT9EQ;ES+ER,cVzEQ;EU0ER,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;AXisDJ;;AW7rDA;EACE,iBAAA;EACA,sBAAA;EACA,qBAAA;AXgsDF;AW9rDE;EALF;IAMI,iBAAA;EXisDF;AACF;AW/rDE;EATF;IAUI,iBAAA;EXksDF;AACF;;AW/rDA;EACE,yBVnGY;EUoGZ,YAAA;EACA,iDAAA;AXksDF;;AY3yDA;EACE,yDAAA;EACA,yBXHQ;EWIR,+BAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AZ8yDF;AY5yDE;EAVF;IAWI,sBAAA;EZ+yDF;AACF;;AY5yDA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AZ+yDF;AY7yDE;EAPF;IAQI,kBAAA;IACA,cAAA;EZgzDF;AACF;AY9yDE;EACE,iBVxBM;EUyBN,cX1BS;AD00Db;AY7yDE;EACE,iBV1BK;EU2BL,cX5BQ;EW6BR,gCVnCQ;EUoCR,gBAAA;AZ+yDJ;AY5yDE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AZ8yDJ;AY5yDI;EALF;IAMI,uBAAA;EZ+yDJ;AACF;AY7yDI;EATF;IAUI,sBAAA;IACA,mBAAA;EZgzDJ;AACF;AY9yDI;EACE,UAAA;EACA,eAAA;AZgzDN;AY9yDM;EAJF;IAKI,YAAA;EZizDN;AACF;;Aa52DA;EACE,yBZDS;EYET,gBAAA;Ab+2DF;;Aa52DA;EACE,aAAA;EAEA,qCAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,cZTW;ADw3Db;Aa72DE;EATF;IAUI,8BAAA;Ebg3DF;AACF;Aa92DE;EAbF;IAcI,0BAAA;Ebi3DF;AACF;Aa/2DE;EACE,gBAAA;Abi3DJ;Aa92DI;EAJF;IAKI,kBAAA;Ebi3DJ;AACF;Aa92DM;EACE,qBAAA;EACA,cZ9BK;EY+BL,oBAAA;Abg3DR;Aa92DQ;EACE,cZjCI;ADi5Dd;Aa52DM;EACE,iBXrCE;EWsCF,qBAAA;Ab82DR;Aa52DQ;EACE,gBAAA;Ab82DV;Aa12DM;EACE,iBX5CC;EW6CD,cZ9CI;EY+CJ,gBAAA;EACA,mBAAA;Ab42DR;Aaz2DM;EAGE,iBXrDC;EWsDD,gCX7DI;EW8DJ,gBAAA;EACA,mBAAA;Aby2DR;Aap2DE;EACE,gBAAA;Abs2DJ;Aap2DI;EAHF;IAII,kBAAA;Ebu2DJ;AACF;Aar2DI;EACE,qBAAA;EACA,cZ1EO;EY2EP,oBAAA;Abu2DN;Aar2DM;EACE,cZ7EM;ADo7Dd;Aan2DI;EACE,iBX/EG;EWgFH,mBAAA;Abq2DN;Aan2DM;EACE,iBXrFE;EWsFF,gBAAA;EACA,yBAAA;EACA,kCX9FM;EW+FN,YAAA;Abq2DR;Aaj2DI;EACE,gCXnGM;EWoGN,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;Abm2DN;Aaj2DM;EAZF;IAaI,WAAA;Ebo2DN;AACF;;Aa/1DA;EACE,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iDAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;Abk2DF;Aah2DE;EACE,gDAAA;EACA,yBAAA;Abk2DJ;;Acv+DA;EACE,WAAA;EACA,aAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;Ad0+DF;Acx+DE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,2CAAA;Ad0+DJ;Acv+DE;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,cbxBS;ADigEb;Acv+DI;EACE,iBAAA;EACA,qBAAA;Ady+DN;Act+DI;EACE,iBZ5BG;EY6BH,gBAAA;Adw+DN;Act+DM;EACE,cbpCK;EaqCL,qBAAA;EACA,oBAAA;Adw+DR;Act+DQ;EACE,cbxCI;ADghEd;;Ach+DA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;Adm+DF;Acj+DE;EAPF;IAQI,aAAA;IACA,0BAAA;IACA,kBAAA;IACA,gBAAA;Edo+DF;AACF;Acl+DE;EAdF;IAeI,eAAA;Edq+DF;AACF;Acn+DE;EACE,YAAA;EACA,aAAA;Adq+DJ;Acn+DI;EAJF;IAKI,cAAA;Eds+DJ;AACF;Acp+DI;EARF;IASI,WAAA;IACA,YAAA;Edu+DJ;AACF;Acp+DE;EACE,cblFS;EamFT,aAAA;EACA,sBAAA;Ads+DJ;Acp+DI;EACE,iBZpFI;EYqFJ,gCZ3FM;EY4FN,gBAAA;EACA,mBAAA;Ads+DN;Acn+DI;EACE,iBZ7FI;EY8FJ,gBAAA;Adq+DN;Acl+DI;EACE,iBZ/FG;EYgGH,cbjGM;EakGN,gCZxGM;EYyGN,gBAAA;EACA,gBAAA;EACA,mBAAA;Ado+DN;Acj+DI;EACE,aAAA;EAEA,kCAAA;EACA,SAAA;Adk+DN;Ach+DM;EANF;IAOI,0BAAA;IACA,cAAA;IACA,MAAA;Edm+DN;Ecj+DM;IACE,aAAA;Edm+DR;AACF;Ach+DM;EACE,aAAA;EACA,sBAAA;Adk+DR;Ach+DQ;EAJF;IAKI,mBAAA;Edm+DR;AACF;Acj+DQ;EACE,WAAA;Adm+DV;Ach+DQ;EACE,WAAA;Adk+DV;Ac/9DQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;Adi+DV;Ac/9DU;EALF;IAMI,kBAAA;IACA,sBAAA;Edk+DV;AACF;Ach+DU;EACE,iBAAA;Adk+DZ;;Ac39DA;EACE,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,cbjKW;AD+nEb;;Ac39DA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,yDAAA;EACA,kBAAA;EACA,gBAAA;Ad89DF;Ac59DE;EARF;IASI,mBAAA;IACA,eAAA;Ed+9DF;AACF;Ac79DE;EACE,yBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;Ad+9DJ;;Ac39DA;EACE,YAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;Ad89DF;Ac59DE;EAVF;IAWI,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,SAAA;IACA,kBAAA;Ed+9DF;AACF;Ac79DE;EACE,iBAAA;Ad+9DJ;Ac59DE;EACE,aAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,cbtNU;EauNV,mBAAA;Ad89DJ;;Ac19DA;EACE,wBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cbpOW;ADisEb;Ac39DE;EACE,YAAA;EACA,mBAAA;Ad69DJ;Ac39DI;EAJF;IAKI,YAAA;IACA,mBAAA;Ed89DJ;AACF;Ac39DE;EACE,iBZ9OM;EY+ON,gCZrPQ;EYsPR,gBAAA;EACA,mBAAA;Ad69DJ;Ac19DE;EACE,iBZvPM;EYwPN,gBAAA;EACA,mBAAA;Ad49DJ;Acz9DE;EACE,iBZ1PK;EY2PL,cb5PQ;Ea6PR,gCZnQQ;EYoQR,gBAAA;Ad29DJ;;Ae/tEA;EACE,aAAA;EACA,kCAAA;EACA,wBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;AfkuEF;AehuEE;EAXF;IAYI,8BAAA;IACA,kBAAA;EfmuEF;AACF;AejuEE;EAhBF;IAiBI,0BAAA;IACA,kBAAA;EfouEF;AACF;AeluEE;EACE,yBAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;EACA,aAAA;AfouEJ;AeluEI;EATF;IAUI,0BAAA;IACA,WAAA;EfquEJ;AACF;AenuEI;EACE,qBAAA;EACA,gBAAA;AfquEN;AepuEM;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;AfsuER;AeluEI;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,cd/CO;ADmxEb;AeluEM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AfouER;AeluEQ;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AfouEV;AeluEU;EACE,iBb3DF;Ea4DE,gBAAA;AfouEZ;AejuEU;EACE,aAAA;EACA,WAAA;AfmuEZ;AejuEY;EACE,iBAAA;EACA,cAAA;AfmuEd;Ae9tEQ;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AfguEV;Ae9tEU;EACE,iBAAA;AfguEZ;Ae7tEU;EACE,iBblFH;AFizET;Ae7tEU;EACE,iBAAA;EACA,cAAA;Af+tEZ;Ae3tEQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;EACA,mBAAA;EACA,cAAA;Af6tEV;Ae5tEU;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;Af8tEZ;Ae7tEY;EACE,WAAA;EACA,eAAA;Af+tEd;Ae7tEY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;Af+tEd;Ae5tEU;EACE,iBAAA;EACA,UAAA;Af8tEZ;Ae5tEc;EACE,cAAA;EACA,gBAAA;EACA,eAAA;Af8tEhB;Ae3tEY;EACE,WAAA;Af6tEd;AextEQ;EACE,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iDAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;Af0tEV;AextEU;EACE,gDAAA;EACA,yBAAA;Af0tEZ;AevtEU;EACE,qBAAA;EACA,YAAA;EACA,gBAAA;AfytEZ;AettEQ;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AfwtEV;AertEM;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;AfutER;AettEQ;EACE,iBAAA;AfwtEV;;AejtEA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;AfotEF;AentEE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AfqtEJ;AentEE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AfqtEJ;AentEE;EACE,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AfqtEJ;;AgBh6EA;EACE,aAAA;EACA,kCAAA;EACA,wBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AhBm6EF;AgBj6EE;EAXF;IAYI,8BAAA;IACA,kBAAA;EhBo6EF;AACF;AgBl6EE;EAhBF;IAiBI,0BAAA;IACA,kBAAA;EhBq6EF;AACF;AgBn6EE;EACE,YAAA;EACA,uBAAA;EACA,iDAAA;AhBq6EJ;AgBn6EI;EALF;IAMI,WAAA;EhBs6EJ;AACF;AgBp6EI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AhBs6EN;AgBr6EM;EACE,WAAA;AhBu6ER;AgBn6EI;EACE,cfrCO;EesCP,aAAA;AhBq6EN;AgBn6EM;EACE,iBdtCE;AF28EV;AgBl6EM;EACE,iBdzCC;Ec0CD,gBAAA;EACA,cAAA;AhBo6ER;;AiBt9EA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,chBFW;EgBGX,mBAAA;EACA,yDAAA;EACA,qBAAA;EACA,kCAAA;EACA,4BAAA;AjBy9EF;AiBv9EE;EAZF;IAaI,0BAAA;IACA,kBAAA;EjB09EF;AACF;AiBx9EE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AjB09EJ;AiBx9EI;EANF;IAOI,cAAA;IACA,mBAAA;EjB29EJ;AACF;AiBz9EI;EACE,iBfzBI;Ee0BJ,gBAAA;EACA,mBAAA;AjB29EN;AiBx9EI;EACE,iBf5BG;Ee6BH,gCfpCM;EeqCN,chB/BM;EgBgCN,gBAAA;EACA,mBAAA;AjB09EN;AiBv9EI;EACE,qBAAA;EACA,chBzCO;EgB0CP,iBftCG;EeuCH,gBAAA;EACA,oBAAA;EACA,qBAAA;AjBy9EN;AiBv9EM;EACE,chB/CM;ADwgFd;AiBp9EE;EACE,aAAA;EACA,sBAAA;AjBs9EJ;AiBp9EI;EACE,aAAA;EACA,sBAAA;AjBs9EN;AiBp9EM;EACE,iBf1DC;Ee2DD,gBAAA;EACA,mBAAA;AjBs9ER;AiBp9EQ;EACE,chBlEI;ADwhFd;AiBl9EM;EACE,yBAAA;EACA,4BAAA;EACA,iBftEC;EeuED,YAAA;EACA,aAAA;EACA,qBAAA;AjBo9ER;AiBj9EM;EACE,yBAAA;EACA,aAAA;EACA,4BAAA;EACA,iBfhFC;EeiFD,YAAA;EACA,aAAA;EACA,qBAAA;AjBm9ER;AiBh9EM;EACE,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iDAAA;EACA,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AjBk9ER;AiBh9EQ;EACE,gDAAA;EACA,yBAAA;AjBk9EV;;AkB7jFA;EACE,gBAAA;AlBgkFF;;AkB7jFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AlBgkFF;;AkB5jFA;EACE,YAAA;EACA,kBAAA;AlB+jFF;AkB7jFE;EAJF;IAKI,WAAA;ElBgkFF;AACF;;AkB7jFA;EACE,WAAA;AlBgkFF;AkB9jFE;EACE,WAAA;EACA,yBjBrBU;EiBsBV,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AlBgkFJ;AkB9jFI;EACE,iBAAA;EACA,gBAAA;AlBgkFN;AkB5jFE;EACE,aAAA;EACA,0BAAA;EACA,wBAAA;EACA,iBAAA;AlB8jFJ;AkB3jFI;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,wBAAA;EACA,sBAAA;EACA,gCAAA;EACA,+BAAA;EACA,8BAAA;AlB6jFN;AkB3jFM;EACE,+BAAA;AlB6jFR;AkB3jFM;EACE,+BAAA;AlB6jFR;;AmBxnFA;EACE,cAAA;AnB2nFF;AmBznFE;EAHF;IAII,aAAA;EnB4nFF;AACF;AmB1nFE;EAPF;IAQI,aAAA;EnB6nFF;AACF;AmB3nFE;EACE,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iDAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AnB6nFJ;AmB5nFI;EACE,gDAAA;EACA,yBAAA;AnB8nFN;AmB3nFI;EACE,qBAAA;EACA,YAAA;EACA,gBAAA;AnB6nFN","sourcesContent":["@use \"./colors\" as *;\n@use \"./typhography\" as *;\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  font-size: 62.5%;\n  scroll-behavior: smooth;\n}\n\nbody {\n  background-color: $bg-white;\n  font-family: $titles-font;\n  position: relative;\n}\n\n.container {\n  max-width: 133rem !important;\n  margin: 0 auto !important;\n  padding: 0 2.5rem !important;\n}\n\n// scroll bar ------\n\n/* Firefox */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #f5272b #ffffff;\n}\n\n/* Chrome, Edge and Safari */\n*::-webkit-scrollbar {\n  width: 10px;\n  width: 10px;\n}\n*::-webkit-scrollbar-track {\n  border-radius: 5px;\n  background-color: #ffffff;\n}\n\n*::-webkit-scrollbar-track:hover {\n  background-color: #ffffff;\n}\n\n*::-webkit-scrollbar-track:active {\n  background-color: #ffffff;\n}\n\n*::-webkit-scrollbar-thumb {\n  border-radius: 20px;\n  background-color: #f5272b;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background-color: #f5272b;\n}\n\n*::-webkit-scrollbar-thumb:active {\n  background-color: #ff2525;\n}\n\ninput[type=\"file\"]::file-selector-button {\n  background-color: #f5272b;\n  border: none;\n  color: #fff;\n  font-size: 10px;\n  padding: 6px;\n  font-weight: 700;\n  border-radius: 4px;\n  margin-top: -6px;\n  margin-bottom: -6px;\n}\n\n.loading_wrapper {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8rem;\n  img {\n    width: 200px;\n  }\n}\n\n.not-found-wrapp {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  flex-direction: column;\n  font-size: 2rem;\n  font-weight: 500;\n  margin-top: 4rem;\n  margin-bottom: -10rem;\n  img {\n    width: 380px;\n  }\n}\n\n.input-container {\n  display: flex;\n  justify-content: end;\n  width: 100%;\n  position: fixed;\n  top: -100px;\n  left: 50%;\n  z-index: 5;\n  transform: translateX(-50%);\n  transition: top 0.3s ease-in-out;\n  background-color: rgba(255, 255, 255, 0.25);\n  backdrop-filter: blur(10px);\n  padding: 10px;\n  border: none;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n\n  transition: background-color 0.3s ease-in-out, backdrop-filter 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n  input {\n    outline: none;\n    background-color: rgb(255 255 255 / 45%);\n    color: #878585;\n    border-radius: 1rem;\n    border: 1px solid #ccd7e6;\n    width: 50%;\n    padding: 0.8rem;\n  }\n  // @media (max-width: 768px) {\n  //   input {\n  //     width: 60%;\n  //   }\n  // }\n}\n\n.input-container.show {\n  top: 0;\n}\n\n.input-datetime[type=\"datetime-local\"] {\n  outline: none;\n  color: #878585;\n  padding-right: 3rem;\n  border: 1px solid #ccd7e6;\n  min-height: 4.5rem;\n  width: 100%;\n}\n\n.dt {\n  outline: none;\n  color: #878585;\n  padding-left: 12px;\n  border: 1px solid #ccd7e6;\n  min-height: 4.5rem;\n  width: 100%;\n}\n\n.rsis-image {\n  background-position: center;\n}\n\n.react-datepicker {\n  font-size: 1.3rem !important;\n}\n\n.react-datepicker__current-month {\n  font-size: 1.5rem !important;\n}\n\n.react-datepicker__header {\n  padding-top: 6px !important;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day {\n  margin: 0.5rem !important;\n}\n\n.react-datepicker__time-container {\n  width: unset !important;\n  .react-datepicker__time .react-datepicker__time-box {\n    width: unset !important;\n  }\n}\n\n.w-100 {\n  width: 100%;\n}\n","* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  font-size: 62.5%;\n  scroll-behavior: smooth;\n}\n\nbody {\n  background-color: #ffffff;\n  font-family: \"Poppins\", sans-serif;\n  position: relative;\n}\n\n.container {\n  max-width: 133rem !important;\n  margin: 0 auto !important;\n  padding: 0 2.5rem !important;\n}\n\n/* Firefox */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #f5272b #ffffff;\n}\n\n/* Chrome, Edge and Safari */\n*::-webkit-scrollbar {\n  width: 10px;\n  width: 10px;\n}\n\n*::-webkit-scrollbar-track {\n  border-radius: 5px;\n  background-color: #ffffff;\n}\n\n*::-webkit-scrollbar-track:hover {\n  background-color: #ffffff;\n}\n\n*::-webkit-scrollbar-track:active {\n  background-color: #ffffff;\n}\n\n*::-webkit-scrollbar-thumb {\n  border-radius: 20px;\n  background-color: #f5272b;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background-color: #f5272b;\n}\n\n*::-webkit-scrollbar-thumb:active {\n  background-color: #ff2525;\n}\n\ninput[type=file]::file-selector-button {\n  background-color: #f5272b;\n  border: none;\n  color: #fff;\n  font-size: 10px;\n  padding: 6px;\n  font-weight: 700;\n  border-radius: 4px;\n  margin-top: -6px;\n  margin-bottom: -6px;\n}\n\n.loading_wrapper {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8rem;\n}\n.loading_wrapper img {\n  width: 200px;\n}\n\n.not-found-wrapp {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  flex-direction: column;\n  font-size: 2rem;\n  font-weight: 500;\n  margin-top: 4rem;\n  margin-bottom: -10rem;\n}\n.not-found-wrapp img {\n  width: 380px;\n}\n\n.input-container {\n  display: flex;\n  justify-content: end;\n  width: 100%;\n  position: fixed;\n  top: -100px;\n  left: 50%;\n  z-index: 5;\n  transform: translateX(-50%);\n  transition: top 0.3s ease-in-out;\n  background-color: rgba(255, 255, 255, 0.25);\n  backdrop-filter: blur(10px);\n  padding: 10px;\n  border: none;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease-in-out, backdrop-filter 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n}\n.input-container input {\n  outline: none;\n  background-color: rgba(255, 255, 255, 0.45);\n  color: #878585;\n  border-radius: 1rem;\n  border: 1px solid #ccd7e6;\n  width: 50%;\n  padding: 0.8rem;\n}\n\n.input-container.show {\n  top: 0;\n}\n\n.input-datetime[type=datetime-local] {\n  outline: none;\n  color: #878585;\n  padding-right: 3rem;\n  border: 1px solid #ccd7e6;\n  min-height: 4.5rem;\n  width: 100%;\n}\n\n.dt {\n  outline: none;\n  color: #878585;\n  padding-left: 12px;\n  border: 1px solid #ccd7e6;\n  min-height: 4.5rem;\n  width: 100%;\n}\n\n.rsis-image {\n  background-position: center;\n}\n\n.react-datepicker {\n  font-size: 1.3rem !important;\n}\n\n.react-datepicker__current-month {\n  font-size: 1.5rem !important;\n}\n\n.react-datepicker__header {\n  padding-top: 6px !important;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day {\n  margin: 0.5rem !important;\n}\n\n.react-datepicker__time-container {\n  width: unset !important;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: unset !important;\n}\n\n.w-100 {\n  width: 100%;\n}\n\n.navbar {\n  max-width: 133rem;\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2.7rem 2rem;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  background-color: transparent;\n  z-index: 999;\n  margin: 0 auto;\n}\n.navbar__img {\n  width: 16.5rem;\n}\n.navbar__img img {\n  width: 100%;\n  height: 100%;\n}\n.navbar__links {\n  display: flex;\n  list-style: none;\n  gap: 2.1rem;\n}\n.navbar__links a {\n  font-size: 1.6rem;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 500;\n  color: #010103;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.navbar__links a:hover {\n  color: #f5272b;\n}\n@media (max-width: 1000px) {\n  .navbar__links {\n    display: none;\n  }\n}\n.navbar__buttons {\n  display: flex;\n  gap: 2.5rem;\n  font-size: 1.6rem;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 500;\n  align-items: center;\n}\n@media (max-width: 1000px) {\n  .navbar__buttons {\n    display: none;\n  }\n}\n.navbar__buttons__sign-in {\n  color: #010103;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.navbar__buttons__sign-in:hover {\n  color: #f5272b;\n}\n.navbar__buttons__register {\n  background-color: #f5272b;\n  color: white;\n  padding: 1rem 2rem;\n  border-radius: 3px;\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.35);\n  transition: all 0.3s;\n}\n.navbar__buttons__register:hover {\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.5);\n  background-color: #fa4226;\n}\n.navbar__buttons a {\n  text-decoration: none;\n}\n\n.mobile-hamb {\n  font-size: 2.8rem;\n  display: flex;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.mobile-hamb:hover {\n  color: #f5272b;\n}\n@media (min-width: 1000px) {\n  .mobile-hamb {\n    display: none;\n  }\n}\n\n.mobile-navbar {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: -100%;\n  background-color: #ffffff;\n  z-index: 999999;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.5s ease-in-out;\n}\n.mobile-navbar__close {\n  font-size: 3rem;\n  position: absolute;\n  top: 3.5rem;\n  right: 3.5rem;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.mobile-navbar__close:hover {\n  color: #f5272b;\n}\n.mobile-navbar__links {\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  font-size: 2.3rem;\n  gap: 3rem;\n  text-align: center;\n}\n.mobile-navbar__links li a {\n  text-decoration: none;\n  color: #010103;\n  font-weight: 500;\n  transition: all 0.3s;\n}\n.mobile-navbar__links li a:hover {\n  color: #f5272b;\n}\n.mobile-navbar .sign_in {\n  background-color: #fa4226;\n  padding: 6px;\n  color: #fff;\n  font-weight: 600;\n  text-decoration: none;\n  border-radius: 4px;\n}\n\n.open-nav {\n  left: 0;\n}\n\n.hero-section {\n  width: 100%;\n  background-color: #f8f8f8;\n  position: relative;\n  overflow: hidden;\n  padding: 15rem 0px;\n}\n@media (max-width: 1000px) {\n  .hero-section {\n    padding: 12rem 0rem 6rem 0rem;\n  }\n}\n\n.bg-shape {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 0;\n}\n@media (max-width: 800px) {\n  .bg-shape {\n    display: none;\n  }\n}\n\n.hero-content {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n@media (max-width: 800px) {\n  .hero-content {\n    justify-content: center;\n  }\n}\n.hero-content__text {\n  display: flex;\n  flex-direction: column;\n  z-index: 3;\n  max-width: 50rem;\n}\n@media (max-width: 800px) {\n  .hero-content__text {\n    text-align: center;\n    align-items: center;\n  }\n}\n.hero-content__text h4 {\n  font-size: 2.2rem;\n  font-family: \"Rubik\", sans-serif;\n  color: #010103;\n}\n.hero-content__text h1 {\n  font-size: 5.2rem;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 700;\n  color: #010103;\n  line-height: 1.2;\n  margin-top: 1rem;\n  margin-bottom: 2.3rem;\n}\n.hero-content__text h1 span {\n  color: #f5272b;\n}\n.hero-content__text p {\n  font-size: 1.6rem;\n  font-family: \"Rubik\", sans-serif;\n  line-height: 1.6;\n  color: #706f7b;\n  margin-bottom: 4rem;\n}\n.hero-content__text__btns {\n  display: flex;\n  gap: 2rem;\n  font-size: 1.6rem;\n  font-family: \"Rubik\", sans-serif;\n}\n@media (max-width: 450px) {\n  .hero-content__text__btns {\n    flex-direction: column;\n  }\n}\n.hero-content__text__btns a {\n  text-decoration: none;\n  color: white;\n  font-weight: 700;\n}\n.hero-content__text__btns__book-ride {\n  background-color: #f5272b;\n  padding: 1.8rem 3rem;\n  border-radius: 0.3rem;\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.35);\n  transition: all 0.3s;\n  border: 2px solid #f5272b;\n}\n@media (max-width: 450px) {\n  .hero-content__text__btns__book-ride {\n    padding: 1.8rem 8rem;\n  }\n}\n.hero-content__text__btns__book-ride:hover {\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.6);\n  background-color: #fa4226;\n}\n.hero-content__text__btns__learn-more {\n  background-color: #010103;\n  padding: 1.8rem 3rem;\n  border-radius: 0.3rem;\n  border: 2px solid #010103;\n  transition: all 0.3s;\n}\n.hero-content__text__btns__learn-more:hover {\n  background-color: transparent;\n  color: #010103;\n}\n.hero-content__car-img {\n  z-index: 2;\n  position: absolute;\n  right: 0;\n  width: 60%;\n}\n@media (max-width: 800px) {\n  .hero-content__car-img {\n    display: none;\n  }\n}\n\n.scroll-up {\n  position: fixed;\n  font-size: 2.5rem;\n  color: white;\n  background-color: #f5272b;\n  border: 3px solid white;\n  width: 2rem;\n  height: 2rem;\n  bottom: 5rem;\n  right: 5rem;\n  z-index: 20;\n  display: none;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  padding: 2rem;\n  cursor: pointer;\n}\n\n.show-scroll {\n  display: flex;\n}\n\n.book-section {\n  position: relative;\n  background: linear-gradient(to bottom, #f8f8f8 20%, #ffffff 80%);\n}\n\n.book-content {\n  margin: 0 auto;\n  margin-bottom: 10rem;\n}\n.book-content__box {\n  background-color: #ffffff;\n  width: 100%;\n  padding: 4rem 4.5rem 5rem 5.5rem;\n  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);\n  height: auto;\n  position: relative;\n  z-index: 4;\n  color: white;\n  border-radius: 5px;\n  background-image: url(\"../../images/book-car/book-bg.png\");\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n  flex-direction: column;\n  color: #010103;\n}\n@media (max-width: 400px) {\n  .book-content__box {\n    padding: 4rem 2.5rem 5rem 2.5rem;\n  }\n}\n.book-content__box__checkbox-group {\n  display: flex;\n  gap: 2rem;\n  width: 100%;\n  margin: 4px 0px;\n  justify-content: flex-end;\n}\n.book-content__box__checkbox-group div {\n  display: flex;\n  align-items: center;\n}\n.book-content__box__checkbox-group div p {\n  color: #777777;\n  font-size: 14px;\n  font-weight: 500;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n@media (max-width: 400px) {\n  .book-content__box__checkbox-group div p {\n    font-size: 12px;\n  }\n}\n.book-content__box h2 {\n  font-size: 2.4rem;\n  font-weight: 700;\n}\n.book-content__box .error-modal {\n  color: #fe3516;\n}\n.book-content__box .box-form {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: auto auto auto;\n  gap: 2rem;\n}\n.book-content__box .box-form b {\n  color: #f5272b;\n}\n@media (max-width: 1000px) {\n  .book-content__box .box-form {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 630px) {\n  .book-content__box .box-form {\n    grid-template-columns: 1fr;\n  }\n}\n.book-content__box .box-form__car-type {\n  display: flex;\n  flex-direction: column;\n}\n.book-content__box .box-form__car-type[id=\"1\"] {\n  grid-column: 1/span 2;\n}\n@media (max-width: 1000px) {\n  .book-content__box .box-form__car-type[id=\"1\"] {\n    grid-column: 1;\n  }\n}\n.book-content__box .box-form__car-type:last-child {\n  grid-column: 2;\n}\n@media (max-width: 1000px) {\n  .book-content__box .box-form__car-type:last-child {\n    grid-column: 1;\n  }\n}\n.book-content__box .box-form__car-type label {\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin-bottom: 1.2rem;\n}\n.book-content__box .box-form__car-type label i {\n  color: #f5272b;\n}\n.book-content__box .box-form__car-type select {\n  font-size: 1.5rem;\n  color: #ababab;\n  font-family: \"Rubik\", sans-serif;\n  border: 1px solid #ccd7e6;\n  border-radius: 3px;\n  font-weight: 400;\n  padding: 1.2rem 1.3rem;\n  outline: none;\n}\n.book-content__box .box-form__car-time {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n.book-content__box .box-form__car-time label {\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin-bottom: 1.2rem;\n}\n.book-content__box .box-form__car-time label i {\n  color: #f5272b;\n}\n.book-content__box .box-form__car-time ::-webkit-datetime-edit {\n  padding: 1.3rem 1.3rem;\n}\n.book-content__box .box-form__car-time ::-webkit-calendar-picker-indicator {\n  cursor: pointer;\n  font-size: 1.6rem;\n}\n.book-content__box .box-form__book-button {\n  width: 100%;\n  align-items: center;\n}\n@media (max-width: 630px) {\n  .book-content__box .box-form__book-button {\n    margin-top: 2rem;\n  }\n}\n.book-content__box .googlemap_input {\n  font-size: 1.5rem;\n  color: #ababab;\n  font-family: \"Rubik\", sans-serif;\n  border: 1px solid #ccd7e6;\n  border-radius: 3px;\n  font-weight: 400;\n  padding: 1.2rem 1.3rem;\n  outline: none;\n  width: 100%;\n}\n.book-content__box__book-button {\n  width: 100%;\n  padding: 1.3rem 1.3rem;\n  height: fit-content;\n  align-self: self-end;\n  border: none;\n  font-family: \"Rubik\", sans-serif;\n  font-size: 1.8rem;\n  font-weight: 500;\n  color: white;\n  background-color: #f5272b;\n  box-shadow: 0 10px 15px rgba(255, 83, 48, 0.35);\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.book-content__box__book-button:hover {\n  box-shadow: 0 10px 15px rgba(255, 83, 48, 0.55);\n}\n\n.error-message {\n  color: #721c24;\n  background-color: #f8d7da;\n  border-color: #f5c6cb;\n  padding: 1rem 1.4rem;\n  margin-bottom: 1.8rem;\n  margin-top: -1rem;\n  border: 1px solid transparent;\n  border-radius: 0.8rem;\n  font-size: 1.6rem;\n  font-weight: 500;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.error-message i {\n  cursor: pointer;\n}\n\n.booking-done {\n  color: #2a6817;\n  background-color: #c3fabe;\n  border-color: #f5c6cb;\n  padding: 1rem 1.4rem;\n  margin-bottom: 1.8rem;\n  margin-top: -1rem;\n  border: 1px solid transparent;\n  border-radius: 0.8rem;\n  font-size: 1.6rem;\n  font-weight: 500;\n  display: none;\n  justify-content: space-between;\n  align-items: center;\n}\n.booking-done i {\n  cursor: pointer;\n}\n\n.active-modal {\n  opacity: 1 !important;\n  display: flex !important;\n}\n\n.modal-overlay {\n  opacity: 0;\n  display: none;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  z-index: 999999999;\n  top: 0;\n  right: 0;\n}\n\n.booking-modal {\n  opacity: 0;\n  display: none;\n  flex-direction: column;\n  position: fixed;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  z-index: 999999999999;\n  top: 54%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 83rem;\n  height: 100vh;\n  border: 2px solid white;\n  background-color: rgb(255, 255, 255);\n  padding-right: 2px;\n  color: #010103;\n}\n@media (max-width: 800px) {\n  .booking-modal {\n    width: 95%;\n    height: 95%;\n  }\n}\n@media (max-width: 600px) {\n  .booking-modal {\n    top: 50%;\n  }\n}\n.booking-modal__title {\n  display: flex;\n  justify-content: space-between;\n  padding: 1rem 1.5rem;\n  background-color: #f5272b;\n  color: white;\n  align-items: center;\n}\n.booking-modal__title h2 {\n  font-size: 2.4rem;\n  text-transform: uppercase;\n}\n.booking-modal__title i {\n  font-size: 2.5rem;\n  color: rgba(255, 255, 255, 0.919);\n  cursor: pointer;\n  transition: all 0.2;\n}\n.booking-modal__title i:hover {\n  color: white;\n}\n.booking-modal__message {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  padding: 2rem 3rem;\n  background-color: #ffeae6;\n}\n.booking-modal__message h4 {\n  font-size: 1.9rem;\n  font-weight: 700;\n  color: #f5272b;\n}\n.booking-modal__message h4 i {\n  font-size: 2.5rem;\n}\n.booking-modal__message p {\n  font-size: 1.7rem;\n  color: #777777;\n  font-weight: 500;\n  line-height: 1.6;\n}\n.booking-modal__car-info {\n  background-color: white;\n  padding: 3rem 3rem;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  border-bottom: 1px solid rgba(119, 119, 119, 0.6235294118);\n}\n@media (max-width: 650px) {\n  .booking-modal__car-info {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n}\n.booking-modal__car-info__dates {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n.booking-modal__car-info__dates h5 {\n  font-size: 1.8rem;\n  color: #f5272b;\n}\n.booking-modal__car-info__dates span {\n  display: flex;\n  gap: 1rem;\n}\n@media (max-width: 650px) {\n  .booking-modal__car-info__dates span {\n    grid-template-columns: 1fr;\n    text-align: center;\n    justify-content: center;\n  }\n}\n.booking-modal__car-info__dates span i {\n  font-size: 1.8rem;\n  padding-top: 0.2rem;\n  color: #777777;\n}\n@media (max-width: 650px) {\n  .booking-modal__car-info__dates span i {\n    display: none;\n  }\n}\n.booking-modal__car-info__dates span h6 {\n  font-size: 1.5rem;\n  margin-bottom: 0.2rem;\n}\n.booking-modal__car-info__dates span p {\n  font-size: 1.6rem;\n  color: #777777;\n}\n.booking-modal__car-info__dates span span {\n  color: #0075ff;\n  font-size: 1.6rem;\n  cursor: pointer;\n  font-weight: 500;\n  align-items: center;\n}\n.booking-modal__car-info__dates span span i {\n  color: #0075ff;\n}\n.booking-modal__car-info__model {\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n}\n@media (max-width: 650px) {\n  .booking-modal__car-info__model {\n    margin-top: 3.5rem;\n  }\n}\n.booking-modal__car-info__model h5 {\n  font-size: 1.8rem;\n  color: #f5272b;\n}\n.booking-modal__car-info__model h5 span {\n  color: #010103;\n}\n.booking-modal__car-info__model img {\n  width: 100%;\n  height: auto;\n}\n.booking-modal__person-info {\n  padding: 3rem 3rem;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n}\n.booking-modal__person-info h4 {\n  font-size: 1.8rem;\n  text-transform: uppercase;\n  color: #f5272b;\n  margin-bottom: 2rem;\n}\n\n.price_note {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n  justify-content: start;\n  margin-top: 1rem;\n  font-size: 11px;\n}\n\n.out_of_town_note {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n  margin-top: 1rem;\n  font-size: 11px;\n}\n\n.input-time {\n  text-align: center;\n  width: 8rem;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.info-form {\n  display: flex;\n  flex-direction: column;\n}\n.info-form__checkbox {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  font-size: 1.6rem;\n  color: #565454;\n  margin-top: 2rem;\n  margin-bottom: 1rem;\n}\n.info-form__checkbox input {\n  width: 1.6rem;\n  height: 1.6rem;\n}\n.info-form__1col {\n  grid-template-columns: 1fr !important;\n}\n.info-form__2col, .info-form__1col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  padding: 1rem 0;\n}\n@media (max-width: 650px) {\n  .info-form__2col, .info-form__1col {\n    grid-template-columns: 1fr;\n  }\n}\n.info-form__2col span, .info-form__1col span {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n.info-form__2col span label, .info-form__1col span label {\n  font-size: 1.6rem;\n  font-weight: 500;\n  color: #777777;\n}\n.info-form__2col span label b, .info-form__1col span label b {\n  color: #f5272b;\n}\n.info-form__2col span input,\n.info-form__2col span textarea, .info-form__1col span input,\n.info-form__1col span textarea {\n  padding: 14px 15px;\n  background-color: #dbdbdb;\n  color: #555;\n  font-size: 1.5rem;\n  font-weight: 500;\n  outline: none;\n  border: none;\n}\n.info-form__2col span select, .info-form__1col span select {\n  padding: 14px 15px;\n  background-color: #dbdbdb;\n  color: #555;\n  font-size: 1.5rem;\n  font-weight: 500;\n  outline: none;\n  border: none;\n}\n.info-form__2col span select option, .info-form__1col span select option {\n  background-color: #fff;\n}\n.info-form__2col span p, .info-form__1col span p {\n  color: #fe3516;\n}\n\n.reserve-button {\n  background-color: transparent;\n  margin: 0 -3rem;\n  padding: 3rem;\n  text-align: right;\n}\n@media (max-width: 650px) {\n  .reserve-button {\n    text-align: center;\n  }\n}\n.reserve-button button {\n  font-size: 2.4rem;\n  color: white;\n  font-weight: 700;\n  background-color: #f5272b;\n  border: 1px solid #fe3516;\n  padding: 1.2rem 2rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.reserve-button button:hover {\n  background-color: #fe3516;\n}\n\n.reserve-button__disabled {\n  margin: 0 -3rem;\n  padding: 3rem;\n  text-align: right;\n}\n@media (max-width: 650px) {\n  .reserve-button__disabled {\n    text-align: center;\n  }\n}\n.reserve-button__disabled button {\n  font-size: 2.4rem;\n  color: white;\n  font-weight: 700;\n  background-color: #ababab;\n  border: 1px solid #ababab;\n  padding: 1.2rem 2rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.dates-div {\n  display: flex;\n  flex-direction: column;\n  gap: 3.2rem;\n}\n\n.price_estimation {\n  color: #f5272b;\n  font-weight: 600;\n}\n\n.aditional_and_prices {\n  padding: 3rem;\n}\n\n.aditional_input {\n  background-color: #dbdbdb;\n  color: #555;\n  font-size: 1.5rem;\n  font-weight: 500;\n  outline: none;\n  border: none;\n  text-align: center;\n  width: 35px;\n}\n\n.map-modal {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n}\n.map-modal.open {\n  display: block;\n}\n.map-modal .modal-content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  padding: 6px;\n  border-radius: 6px;\n  width: 600px;\n}\n@media (max-width: 650px) {\n  .map-modal .modal-content {\n    width: 90vw;\n  }\n}\n.map-modal .map-container {\n  width: 100%;\n  height: 380px;\n}\n.map-modal .button-container {\n  margin-top: 10px;\n  padding: 8px 0;\n  display: flex;\n  gap: 12px;\n}\n.map-modal .button-container button {\n  padding: 8px 12px;\n  border: none;\n  font-size: 18px;\n  color: white;\n  border-radius: 2px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n@media (max-width: 650px) {\n  .map-modal .button-container button {\n    font-size: 16px;\n  }\n}\n.map-modal .button-container button.save {\n  background-color: #f5272b;\n}\n.map-modal .button-container button.close {\n  background-color: #000000;\n}\n.map-modal .button-container button:hover {\n  opacity: 0.8;\n}\n.map-modal .address-info {\n  padding: 8px;\n  background-color: #f8f8f8;\n  border-radius: 2px;\n  font-size: 14px;\n}\n\n.plan-section {\n  background-color: #ffffff;\n  padding: 5.3rem 0;\n}\n\n.plan-container {\n  display: flex;\n  flex-direction: column;\n}\n.plan-container__title {\n  margin: 0 auto;\n  text-align: center;\n  color: #010103;\n}\n.plan-container__title h3 {\n  font-size: 2.4rem;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 500;\n}\n.plan-container__title h2 {\n  font-size: 4.2rem;\n  font-family: \"Poppins\", sans-serif;\n  margin: 1.3rem 0 3rem 0;\n}\n.plan-container__boxes {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-rows: auto;\n  margin-top: 3.7rem;\n  padding: 0 3rem;\n}\n@media (max-width: 1021px) {\n  .plan-container__boxes {\n    grid-template-columns: 1fr 1fr;\n    row-gap: 2rem;\n  }\n}\n@media (max-width: 800px) {\n  .plan-container__boxes {\n    grid-template-columns: 1fr;\n    margin-top: 1rem;\n  }\n}\n.plan-container__boxes__box {\n  text-align: center;\n  padding: 1rem 6rem;\n}\n@media (max-width: 500px) {\n  .plan-container__boxes__box {\n    padding: 1rem 1rem;\n  }\n}\n.plan-container__boxes__box img {\n  width: 17rem;\n  height: auto;\n}\n.plan-container__boxes__box h3 {\n  font-size: 2.4rem;\n  margin-bottom: 1rem;\n}\n.plan-container__boxes__box p {\n  font-size: 1.6rem;\n  font-family: \"Rubik\", sans-serif;\n  color: #706f7b;\n  line-height: 1.43;\n}\n\n.pick-section {\n  padding: 10rem 0;\n}\n\n.pick-container {\n  display: flex;\n  flex-direction: column;\n}\n.pick-container__title {\n  margin: 0 auto;\n  text-align: center;\n  color: #010103;\n  max-width: 50rem;\n  margin-bottom: 5rem;\n}\n.pick-container__title p {\n  font-size: 1.6rem;\n  font-family: \"Rubik\", sans-serif;\n  color: #706f7b;\n  line-height: 1.5;\n}\n.pick-container__title h3 {\n  font-size: 2.4rem;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 500;\n}\n.pick-container__title h2 {\n  font-size: 4.2rem;\n  font-family: \"Poppins\", sans-serif;\n  margin: 0.5rem 0 1rem 0;\n}\n.pick-container__car-content {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n}\n@media (max-width: 1050px) {\n  .pick-container__car-content {\n    flex-direction: column;\n    gap: 5rem;\n  }\n}\n\n.pick-box {\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  margin-bottom: 4px;\n}\n.pick-box button {\n  font-size: 2rem;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  padding: 1.5rem 2.5rem;\n  background-color: #e9e9e9;\n  transition: all 0.2s;\n  text-align: left;\n}\n.pick-box button:hover {\n  background-color: #f5272b;\n  color: white;\n}\n\n.pick-car {\n  width: 50rem;\n  position: relative;\n}\n@media (max-width: 700px) {\n  .pick-car {\n    width: 100%;\n  }\n}\n.pick-car img {\n  width: 100%;\n  margin-top: 6rem;\n}\n\n.pick-description {\n  width: 25rem;\n}\n.pick-description__price {\n  width: 100%;\n  background-color: #f5272b;\n  font-size: 1.8rem;\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  color: white;\n  padding: 0.3rem 1.9rem;\n}\n.pick-description__price span {\n  font-size: 2.5rem;\n  font-weight: 700;\n}\n.pick-description__table {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto;\n  font-size: 1.4rem;\n}\n.pick-description__table__col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  text-align: center;\n  grid-template-rows: auto;\n  padding: 0.9rem 0.5rem;\n  border-bottom: 2px solid #706f7b;\n  border-right: 2px solid #706f7b;\n  border-left: 2px solid #706f7b;\n}\n.pick-description__table__col span:nth-child(1) {\n  border-right: 2px solid #706f7b;\n}\n\n.cta-btn {\n  font-size: 2rem;\n  text-transform: uppercase;\n  text-decoration: none;\n  font-weight: 600;\n  color: white;\n  font-family: \"Poppins\", sans-serif;\n  background-color: #f5272b;\n  padding: 1rem 1rem;\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  margin-top: 1.4rem;\n  transition: all 0.3s;\n  box-shadow: 6px 6px 0 #efe9e9;\n}\n.cta-btn:hover {\n  background-color: #e9381d;\n}\n\n.box-cars {\n  gap: 11rem;\n  display: flex;\n  justify-content: space-between;\n}\n@media (max-width: 1200px) {\n  .box-cars {\n    gap: 2rem;\n  }\n}\n@media (max-width: 700px) {\n  .box-cars {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 5rem;\n  }\n}\n\n.colored-button {\n  background-color: #f5272b !important;\n  color: white;\n}\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border: 5px solid rgba(0, 0, 0, 0.2588235294);\n  border-bottom-color: #ff3d00;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  top: 40%;\n  right: 43%;\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.banner-section {\n  width: 100%;\n  height: auto;\n  display: flex;\n  background-color: #1b2335;\n  margin: 8rem 0;\n  padding: 6rem 0;\n  text-align: center;\n}\n\n.banner-content {\n  color: white;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n}\n.banner-content__text {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n.banner-content__text h2 {\n  font-size: 5.2rem;\n  line-height: 1.3;\n}\n@media (max-width: 550px) {\n  .banner-content__text h2 {\n    font-size: 4.2rem;\n  }\n}\n.banner-content__text p {\n  font-size: 2.4rem;\n}\n@media (max-width: 550px) {\n  .banner-content__text p {\n    font-size: 2rem;\n  }\n}\n.banner-content__text span {\n  color: #f5272b;\n  font-weight: 500;\n}\n\n.choose-section {\n  background-color: white;\n  padding: 2rem 0 10rem 0;\n  background-image: url(\"../../images/chooseUs/bg.png\");\n  background-position: -225px 255px;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.choose-container {\n  display: flex;\n  flex-direction: column;\n}\n.choose-container__img {\n  width: 90%;\n  height: auto;\n  margin: 0 auto;\n}\n@media (max-width: 550px) {\n  .choose-container__img {\n    width: 100%;\n  }\n}\n\n.text-container {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 3rem;\n  width: 100%;\n}\n@media (max-width: 1000px) {\n  .text-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 5.5rem;\n  }\n}\n.text-container__left {\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  max-width: 50rem;\n  color: #010103;\n}\n@media (max-width: 1000px) {\n  .text-container__left {\n    align-items: center;\n    text-align: center;\n  }\n}\n.text-container__left h4 {\n  font-size: 2.2rem;\n  margin-bottom: 0.7rem;\n  font-weight: 600;\n  font-family: \"Rubik\", sans-serif;\n}\n.text-container__left h2 {\n  font-size: 4.2rem;\n  line-height: 1.2;\n  margin-bottom: 2rem;\n}\n.text-container__left p {\n  font-size: 1.6rem;\n  font-family: \"Rubik\", sans-serif;\n  line-height: 1.5;\n  color: #706f7b;\n  margin-bottom: 3.3rem;\n}\n.text-container__left a {\n  text-decoration: none;\n  color: white;\n  font-weight: 700;\n  background-color: #f5272b;\n  padding: 1.5rem 2.5rem;\n  border-radius: 0.3rem;\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.35);\n  transition: all 0.3s;\n  border: 2px solid #f5272b;\n  font-size: 1.6rem;\n  width: fit-content;\n}\n.text-container__left a:hover {\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.6);\n  background-color: #fa4226;\n}\n.text-container__right {\n  display: flex;\n  flex-direction: column;\n  gap: 4.5rem;\n  max-width: 44rem;\n}\n.text-container__right__box {\n  display: flex;\n}\n@media (max-width: 550px) {\n  .text-container__right__box {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n.text-container__right__box img {\n  width: 11rem;\n  height: 11rem;\n  margin-right: 1.1rem;\n}\n.text-container__right__box__text {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  justify-content: center;\n}\n.text-container__right__box__text h4 {\n  font-size: 2.4rem;\n}\n.text-container__right__box__text p {\n  font-size: 1.6rem;\n  color: #706f7b;\n  font-family: \"Rubik\", sans-serif;\n  line-height: 1.3;\n}\n\n.testimonials-section {\n  background-color: #f8f8f8;\n  padding: 10rem 0;\n  color: #010103;\n}\n\n.testimonials-content {\n  display: flex;\n  flex-direction: column;\n}\n.testimonials-content__title {\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  text-align: center;\n  margin-bottom: 5rem;\n  max-width: 700px;\n}\n.testimonials-content__title h4 {\n  font-size: 2.2rem;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 500;\n}\n.testimonials-content__title h2 {\n  font-size: 4.2rem;\n  margin-bottom: 1.4rem;\n}\n.testimonials-content__title p {\n  font-size: 1.6rem;\n  font-family: \"Rubik\", sans-serif;\n  color: #706f7b;\n  line-height: 1.4;\n}\n\n.all-testimonials {\n  display: flex;\n  gap: 3rem;\n  width: 100%;\n  justify-content: flex-start;\n  padding: 3rem;\n  overflow-x: scroll;\n}\n.all-testimonials::-webkit-scrollbar {\n  height: 8px;\n}\n.all-testimonials::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n.all-testimonials::-webkit-scrollbar-thumb {\n  background: #f5272b;\n  border-radius: 10px;\n}\n.all-testimonials__box {\n  background-color: white;\n  box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.08);\n  width: 30%;\n  padding: 2rem;\n  position: relative;\n  flex-shrink: 0;\n  scroll-snap-align: center;\n  border-radius: 10px;\n  white-space: normal;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n@media (max-width: 1000px) {\n  .all-testimonials__box {\n    width: 90%;\n    padding: 4rem;\n  }\n}\n.all-testimonials__box p {\n  font-size: 1.5rem;\n  font-weight: 500;\n  max-height: 250px;\n  overflow-y: auto;\n}\n.all-testimonials__box .rating {\n  color: #ffcc00;\n  display: flex;\n  gap: 2px;\n  margin-bottom: 1.5rem;\n  justify-content: space-between;\n  align-items: center;\n}\n.all-testimonials__box .rating i {\n  font-size: 2rem;\n}\n.all-testimonials__box .rating .left {\n  display: flex;\n  align-items: center;\n}\n.all-testimonials__box .rating .left p {\n  color: #010103;\n  margin-right: 1rem;\n}\n.all-testimonials__box .rating img {\n  width: 2rem;\n  height: auto;\n}\n.all-testimonials__box__name {\n  display: flex;\n}\n.all-testimonials__box__name__profile {\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n  margin-top: 3rem;\n}\n.all-testimonials__box__name__profile img {\n  width: 7rem;\n  height: 7rem;\n  border-radius: 50%;\n}\n.all-testimonials__box__name__profile h4 {\n  font-size: 1.8rem;\n}\n.all-testimonials__box__name__profile p {\n  font-size: 1.6rem;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 400;\n}\n\n.quotes-icon {\n  font-size: 6.2rem;\n  color: #f5272b;\n  position: absolute;\n  bottom: 33px;\n  right: 60px;\n}\n@media (max-width: 470px) {\n  .quotes-icon {\n    display: none;\n  }\n}\n\n@media (max-width: 600px) {\n  .testimonials-section {\n    padding: 5rem 0;\n  }\n  .all-testimonials {\n    padding: 0rem;\n  }\n  .all-testimonials__box {\n    width: 85%;\n    padding: 3rem;\n  }\n}\n.footer {\n  background-color: white;\n  width: fit-content;\n  margin: auto;\n  padding: 3rem 5rem;\n  margin-top: 3rem;\n  border-radius: 1rem;\n  text-align: center;\n}\n.footer .google {\n  display: flex;\n  align-items: center;\n}\n.footer .google img {\n  width: 3rem;\n  height: auto;\n  margin-right: 1rem;\n}\n.footer .google p {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #010103;\n}\n.footer .rating {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.footer .rating span {\n  font-size: 1.5rem;\n}\n.footer .rating i {\n  color: #ffcc00;\n  font-size: 1.5rem;\n}\n.footer .rating {\n  margin-bottom: 8px;\n  margin-top: 4px;\n}\n\n.all-testimonials::-webkit-scrollbar {\n  display: none;\n}\n\n.all-testimonials {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n.faq-section {\n  background-image: url(\"../../images/faq/veloz.png\");\n  padding: 10rem 0;\n  background-size: auto;\n  background-repeat: no-repeat;\n  background-position: 0 70%;\n}\n\n.faq-content {\n  display: flex;\n  flex-direction: column;\n  color: #010103;\n}\n.faq-content__title {\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  text-align: center;\n  max-width: 80rem;\n  line-height: 1.5;\n}\n.faq-content__title h5 {\n  font-size: 2.2rem;\n}\n.faq-content__title h2 {\n  font-size: 4.2rem;\n  margin-bottom: 1.7rem;\n}\n.faq-content__title p {\n  font-size: 1.6rem;\n  color: #706f7b;\n}\n\n.all-questions {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 7rem;\n}\n\n.faq-box {\n  display: flex;\n  flex-direction: column;\n  color: #010103;\n  background-color: white;\n  box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.1);\n  width: 80rem;\n  cursor: pointer;\n}\n@media (max-width: 850px) {\n  .faq-box {\n    width: 100%;\n  }\n}\n.faq-box__question {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);\n  padding: 1.8rem 4.5rem;\n  transition: 0.15s ease;\n}\n.faq-box__question p {\n  font-size: 1.8rem;\n  font-weight: 500;\n}\n.faq-box__question i {\n  font-size: 2rem;\n}\n.faq-box__answer {\n  font-size: 1.6rem;\n  font-family: \"Rubik\", sans-serif;\n  color: #706f7b;\n  line-height: 1.7;\n  max-height: 0;\n  overflow: hidden;\n  transition: 0.4s ease;\n  padding: 0 4.5rem;\n}\n\n.active-answer {\n  max-height: 20rem;\n  padding: 2.8rem 4.5rem;\n  transition: 0.4s ease;\n}\n@media (max-width: 550px) {\n  .active-answer {\n    max-height: 30rem;\n  }\n}\n@media (max-width: 420px) {\n  .active-answer {\n    max-height: 55rem;\n  }\n}\n\n.active-question {\n  background-color: #f5272b;\n  color: white;\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.35);\n}\n\n.download-section {\n  background-image: url(\"../../images/banners/bg02.png\");\n  background-color: #f8f8f8;\n  background-position: top center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 100%;\n  height: auto;\n  padding: 10rem 0;\n}\n@media (max-width: 700px) {\n  .download-section {\n    background-image: none;\n  }\n}\n\n.download-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  max-width: 55rem;\n  text-align: left;\n}\n@media (max-width: 700px) {\n  .download-text {\n    text-align: center;\n    margin: 0 auto;\n  }\n}\n.download-text h2 {\n  font-size: 4.2rem;\n  color: #010103;\n}\n.download-text p {\n  font-size: 1.6rem;\n  color: #706f7b;\n  font-family: \"Rubik\", sans-serif;\n  line-height: 1.5;\n}\n.download-text__btns {\n  display: flex;\n  gap: 3rem;\n  margin-top: 2rem;\n}\n@media (max-width: 700px) {\n  .download-text__btns {\n    justify-content: center;\n  }\n}\n@media (max-width: 550px) {\n  .download-text__btns {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n.download-text__btns img {\n  width: 40%;\n  cursor: pointer;\n}\n@media (max-width: 550px) {\n  .download-text__btns img {\n    width: 22rem;\n  }\n}\n\nfooter {\n  background-color: #ffffff;\n  padding: 10rem 0;\n}\n\n.footer-content {\n  display: grid;\n  color: #010103;\n  grid-template-columns: 40fr 30fr 30fr;\n  gap: 8rem;\n  justify-content: center;\n  text-align: left;\n  color: #010103;\n}\n@media (max-width: 1100px) {\n  .footer-content {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n@media (max-width: 650px) {\n  .footer-content {\n    grid-template-columns: 1fr;\n  }\n}\n.footer-content__1 {\n  list-style: none;\n}\n@media (max-width: 650px) {\n  .footer-content__1 {\n    text-align: center;\n  }\n}\n.footer-content__1 li a {\n  text-decoration: none;\n  color: #010103;\n  transition: all 0.2s;\n}\n.footer-content__1 li a:hover {\n  color: #f5272b;\n}\n.footer-content__1 li:nth-child(1) {\n  font-size: 2.4rem;\n  margin-bottom: 1.5rem;\n}\n.footer-content__1 li:nth-child(1) span {\n  font-weight: 700;\n}\n.footer-content__1 li:nth-child(2) {\n  font-size: 1.6rem;\n  color: #706f7b;\n  line-height: 1.7;\n  margin-bottom: 3rem;\n}\n.footer-content__1 li:nth-child(3), .footer-content__1 li:nth-child(4), .footer-content__1 li:nth-child(5) {\n  font-size: 1.6rem;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 500;\n  margin-bottom: 1rem;\n}\n.footer-content__2 {\n  list-style: none;\n}\n@media (max-width: 650px) {\n  .footer-content__2 {\n    text-align: center;\n  }\n}\n.footer-content__2 a {\n  text-decoration: none;\n  color: #010103;\n  transition: all 0.2s;\n}\n.footer-content__2 a:hover {\n  color: #f5272b;\n}\n.footer-content__2 li {\n  font-size: 1.6rem;\n  margin-bottom: 1rem;\n}\n.footer-content__2 li:nth-child(1) {\n  font-size: 2.4rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  font-family: \"Poppins\", sans-serif;\n  cursor: auto;\n}\n.footer-content__2 input {\n  font-family: \"Rubik\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 26px;\n  background-color: #ececec;\n  border-width: 1px;\n  border-color: transparent;\n  padding: 10px 60px;\n  outline: none;\n  margin-top: 1rem;\n}\n@media (max-width: 1100px) {\n  .footer-content__2 input {\n    width: 100%;\n  }\n}\n\n.submit-email {\n  text-decoration: none;\n  color: white;\n  font-weight: 700;\n  background-color: #f5272b;\n  padding: 1.5rem 2.5rem;\n  border-radius: 0.3rem;\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.25);\n  transition: all 0.3s;\n  border: 2px solid #f5272b;\n  font-size: 1.6rem;\n  width: fit-content;\n  cursor: pointer;\n  width: 100%;\n}\n.submit-email:hover {\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.4);\n  background-color: #fa4226;\n}\n\n.hero-pages {\n  width: 100%;\n  height: 41rem;\n  background-image: url(\"../../images/hero/camry.webp\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: relative;\n}\n.hero-pages__overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: rgba(255, 255, 255, 0.92);\n}\n.hero-pages__text {\n  display: flex;\n  flex-direction: column;\n  z-index: 3;\n  position: relative;\n  width: 100%;\n  height: 41rem;\n  justify-content: center;\n  color: #010103;\n}\n.hero-pages__text h3 {\n  font-size: 3.6rem;\n  margin-bottom: 0.5rem;\n}\n.hero-pages__text p {\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n.hero-pages__text p a {\n  color: #010103;\n  text-decoration: none;\n  transition: all 0.2s;\n}\n.hero-pages__text p a:hover {\n  color: #f5272b;\n}\n\n.about-main {\n  margin: 10rem auto;\n  display: flex;\n  gap: 5rem;\n  max-width: 90rem;\n  align-items: center;\n}\n@media (max-width: 960px) {\n  .about-main {\n    display: grid;\n    grid-template-columns: 1fr;\n    text-align: center;\n    max-width: 49rem;\n  }\n}\n@media (max-width: 520px) {\n  .about-main {\n    max-width: 100%;\n  }\n}\n.about-main__img {\n  width: 43rem;\n  height: 43rem;\n}\n@media (max-width: 960px) {\n  .about-main__img {\n    margin: 0 auto;\n  }\n}\n@media (max-width: 520px) {\n  .about-main__img {\n    width: 100%;\n    height: auto;\n  }\n}\n.about-main__text {\n  color: #010103;\n  display: flex;\n  flex-direction: column;\n}\n.about-main__text h3 {\n  font-size: 2.2rem;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 500;\n  margin-bottom: 1rem;\n}\n.about-main__text h2 {\n  font-size: 4.2rem;\n  line-height: 1.2;\n}\n.about-main__text p {\n  font-size: 1.6rem;\n  color: #706f7b;\n  font-family: \"Rubik\", sans-serif;\n  line-height: 1.5;\n  margin-top: 2rem;\n  margin-bottom: 4rem;\n}\n.about-main__text__icons {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 4rem;\n}\n@media (max-width: 520px) {\n  .about-main__text__icons {\n    grid-template-columns: 1fr;\n    margin: 0 auto;\n    gap: 0;\n  }\n  .about-main__text__icons p {\n    margin-top: 0;\n  }\n}\n.about-main__text__icons__box {\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 520px) {\n  .about-main__text__icons__box {\n    align-items: center;\n  }\n}\n.about-main__text__icons__box .last-fk {\n  width: 5rem;\n}\n.about-main__text__icons__box img {\n  width: 7rem;\n}\n.about-main__text__icons__box span {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n@media (max-width: 520px) {\n  .about-main__text__icons__box span {\n    text-align: center;\n    flex-direction: column;\n  }\n}\n.about-main__text__icons__box span h4 {\n  font-size: 4.6rem;\n}\n\n.close-icon {\n  background-color: white;\n  padding: 8px;\n  border: 1px solid #706f7b;\n  color: #010103;\n}\n\n.book-banner {\n  display: flex;\n  width: 100%;\n  height: 20rem;\n  background-image: url(\"../../images/banners/book-banner.png\");\n  position: relative;\n  margin-top: 7rem;\n}\n@media (max-width: 750px) {\n  .book-banner {\n    height: fit-content;\n    padding: 1rem 0;\n  }\n}\n.book-banner__overlay {\n  background-color: #1b2335;\n  opacity: 0.89;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.text-content {\n  color: white;\n  z-index: 5;\n  position: relative;\n  width: 100%;\n  height: 20rem;\n  display: flex;\n  align-items: center;\n  gap: 5rem;\n}\n@media (max-width: 750px) {\n  .text-content {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    text-align: center;\n  }\n}\n.text-content h2 {\n  font-size: 3.2rem;\n}\n.text-content span {\n  display: flex;\n  font-size: 2.7rem;\n  gap: 1rem;\n  align-items: center;\n  color: #f5272b;\n  white-space: nowrap;\n}\n\n.about-company-section {\n  margin: 8rem auto 0 auto;\n  padding-bottom: 6rem;\n  max-width: 80rem;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: #010103;\n}\n.about-company-section__logo {\n  width: 36rem;\n  margin-bottom: 8rem;\n}\n@media (max-width: 520px) {\n  .about-company-section__logo {\n    width: 18rem;\n    margin-bottom: 4rem;\n  }\n}\n.about-company-section__subtitle {\n  font-size: 2.2rem;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 500;\n  margin-bottom: 1rem;\n}\n.about-company-section__title {\n  font-size: 4.2rem;\n  line-height: 1.2;\n  margin-bottom: 2rem;\n}\n.about-company-section__description {\n  font-size: 1.6rem;\n  color: #706f7b;\n  font-family: \"Rubik\", sans-serif;\n  line-height: 1.6;\n}\n\n.models-div {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-rows: auto;\n  gap: 3rem;\n  align-items: center;\n  text-align: center;\n  padding: 10rem 0;\n  width: 110rem;\n  margin: 0 auto;\n}\n@media (max-width: 1150px) {\n  .models-div {\n    grid-template-columns: 1fr 1fr;\n    width: fit-content;\n  }\n}\n@media (max-width: 800px) {\n  .models-div {\n    grid-template-columns: 1fr;\n    width: fit-content;\n  }\n}\n.models-div__box {\n  border: 1px solid #d5d5d5;\n  border-radius: 0.3rem;\n  display: flex;\n  width: 35rem;\n  flex-direction: column;\n  justify-content: end;\n  height: 58rem;\n}\n@media (max-width: 400px) {\n  .models-div__box {\n    grid-template-columns: 1fr;\n    width: 100%;\n  }\n}\n.models-div__box__img {\n  border-radius: 0.3rem;\n  overflow: hidden;\n}\n.models-div__box__img img {\n  display: block;\n  width: 100%;\n  max-height: 24rem;\n  object-fit: cover;\n}\n.models-div__box__descr {\n  padding: 3rem 3rem;\n  display: flex;\n  flex-direction: column;\n  color: #010103;\n}\n.models-div__box__descr__name-price {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.models-div__box__descr__name-price__name {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  gap: 0.5rem;\n}\n.models-div__box__descr__name-price__name p {\n  font-size: 2.4rem;\n  font-weight: 700;\n}\n.models-div__box__descr__name-price__name span {\n  display: flex;\n  gap: 0.4rem;\n}\n.models-div__box__descr__name-price__name span i {\n  font-size: 1.4rem;\n  color: #ffc933;\n}\n.models-div__box__descr__name-price__price {\n  display: flex;\n  flex-direction: row;\n  text-align: right;\n}\n.models-div__box__descr__name-price__price h4 {\n  font-size: 2.8rem;\n}\n.models-div__box__descr__name-price__price p {\n  font-size: 1.6rem;\n}\n.models-div__box__descr__name-price__price i {\n  font-size: 1.4rem;\n  color: #ffc933;\n}\n.models-div__box__descr__name-price__details {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n  gap: 6px;\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n  border-bottom: 1px solid #c6c6c6;\n  align-items: center;\n  height: 8.5rem;\n}\n.models-div__box__descr__name-price__details__self-prices {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  text-align: start;\n}\n.models-div__box__descr__name-price__details__self-prices p {\n  color: grey;\n  font-size: 12px;\n}\n.models-div__box__descr__name-price__details__self-prices span {\n  font-size: 20px;\n  font-weight: 700;\n  color: #f5272b;\n}\n.models-div__box__descr__name-price__details__includes {\n  text-align: start;\n  width: 50%;\n}\n.models-div__box__descr__name-price__details__includes div span {\n  color: #010103;\n  font-weight: 600;\n  font-size: 12px;\n}\n.models-div__box__descr__name-price__details__includes p {\n  color: grey;\n}\n.models-div__box__descr__name-price__btn {\n  background-color: #f5272b;\n  padding: 1.8rem 3rem;\n  border-radius: 0.3rem;\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.35);\n  transition: all 0.3s;\n  border: 2px solid #f5272b;\n  font-size: 1.8rem;\n  cursor: pointer;\n}\n.models-div__box__descr__name-price__btn:hover {\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.6);\n  background-color: #fa4226;\n}\n.models-div__box__descr__name-price__btn a {\n  text-decoration: none;\n  color: white;\n  font-weight: 700;\n}\n.models-div__box__descr__name-price__h2 {\n  color: #ccc;\n  margin-top: 8;\n  font-weight: 600;\n  height: 65px;\n}\n.models-div__box__descr__specification {\n  display: flex;\n  gap: 2rem;\n  padding: 1rem;\n  justify-content: space-between;\n  margin-top: -12px;\n}\n.models-div__box__descr__specification i {\n  font-size: 1.5rem;\n}\n\n.dialog_modal {\n  text-align: center;\n  border-radius: 18px;\n  padding: 3rem;\n}\n.dialog_modal h2 {\n  color: #13c39c;\n  font-size: 2.5rem;\n  margin-top: 2rem;\n  font-weight: 600;\n}\n.dialog_modal p {\n  color: #ababab;\n  margin-top: 0.5rem;\n  margin-bottom: 4rem;\n  max-width: 312px;\n  font-size: 12px;\n}\n.dialog_modal button {\n  border: none;\n  background-color: #13c39c;\n  color: #fff;\n  padding: 10px 24px;\n  border-radius: 4px;\n  font-weight: 600;\n}\n\n.team-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-rows: auto;\n  gap: 4rem;\n  align-items: center;\n  text-align: center;\n  padding: 10rem 2rem;\n  width: 110rem;\n  margin: 0 auto;\n}\n@media (max-width: 1150px) {\n  .team-container {\n    grid-template-columns: 1fr 1fr;\n    width: fit-content;\n  }\n}\n@media (max-width: 800px) {\n  .team-container {\n    grid-template-columns: 1fr;\n    width: fit-content;\n  }\n}\n.team-container__box {\n  width: 33rem;\n  background-color: white;\n  box-shadow: 0px 20px 10px 0px rgba(0, 0, 0, 0.08);\n}\n@media (max-width: 400px) {\n  .team-container__box {\n    width: 100%;\n  }\n}\n.team-container__box__img-div {\n  width: 100%;\n  height: auto;\n  background-color: #f6f6f6;\n}\n.team-container__box__img-div img {\n  width: 100%;\n}\n.team-container__box__descr {\n  color: #010103;\n  padding: 3rem;\n}\n.team-container__box__descr h3 {\n  font-size: 2.2rem;\n}\n.team-container__box__descr p {\n  font-size: 1.6rem;\n  font-weight: 500;\n  color: #777777;\n}\n\n.contact-div {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n  margin: 0 auto;\n  color: #010103;\n  padding: 10rem 2rem;\n  background-image: url(\"../../images/banners/bg-contact.png\");\n  background-size: auto;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n@media (max-width: 950px) {\n  .contact-div {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n}\n.contact-div__text {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  max-width: 41rem;\n}\n@media (max-width: 950px) {\n  .contact-div__text {\n    margin: 0 auto;\n    margin-bottom: 2rem;\n  }\n}\n.contact-div__text h2 {\n  font-size: 4.2rem;\n  line-height: 1.3;\n  margin-bottom: 2rem;\n}\n.contact-div__text p {\n  font-size: 1.6rem;\n  font-family: \"Rubik\", sans-serif;\n  color: #706f7b;\n  line-height: 1.6;\n  margin-bottom: 2rem;\n}\n.contact-div__text a {\n  text-decoration: none;\n  color: #010103;\n  font-size: 1.6rem;\n  font-weight: 500;\n  transition: all 0.2s;\n  margin-bottom: 0.5rem;\n}\n.contact-div__text a:hover {\n  color: #f5272b;\n}\n.contact-div__form {\n  display: flex;\n  flex-direction: column;\n}\n.contact-div__form form {\n  display: flex;\n  flex-direction: column;\n}\n.contact-div__form form label {\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n.contact-div__form form label b {\n  color: #f5272b;\n}\n.contact-div__form form input {\n  background-color: #f2f2f2;\n  padding: 19px 30px 19px 30px;\n  font-size: 1.6rem;\n  border: none;\n  outline: none;\n  margin-bottom: 2.3rem;\n}\n.contact-div__form form textarea {\n  background-color: #f2f2f2;\n  height: 18rem;\n  padding: 19px 30px 19px 30px;\n  font-size: 1.6rem;\n  border: none;\n  outline: none;\n  margin-bottom: 2.5rem;\n}\n.contact-div__form form button {\n  background-color: #f5272b;\n  padding: 1.8rem 3rem;\n  border-radius: 0.3rem;\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.35);\n  transition: all 0.3s;\n  border: 2px solid #f5272b;\n  color: white;\n  font-size: 1.8rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n.contact-div__form form button:hover {\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.6);\n  background-color: #fa4226;\n}\n\n.estimate-section {\n  padding: 10rem 0;\n}\n\n.estimate-box {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.estimate-car {\n  width: 50rem;\n  position: relative;\n}\n@media (max-width: 700px) {\n  .estimate-car {\n    width: 100%;\n  }\n}\n\n.estimate-description {\n  width: 100%;\n}\n.estimate-description__price {\n  width: 100%;\n  background-color: #f5272b;\n  font-size: 1.8rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  padding: 0.3rem 1.9rem;\n  white-space: nowrap;\n}\n.estimate-description__price span {\n  font-size: 2.5rem;\n  font-weight: 700;\n}\n.estimate-description__table {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto;\n  font-size: 1.4rem;\n}\n.estimate-description__table__col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  text-align: center;\n  grid-template-rows: auto;\n  padding: 0.9rem 0.5rem;\n  border-bottom: 2px solid #706f7b;\n  border-right: 2px solid #706f7b;\n  border-left: 2px solid #706f7b;\n}\n.estimate-description__table__col span:nth-child(1) {\n  border-right: 2px solid #706f7b;\n}\n.estimate-description__table__col h4:nth-child(1) {\n  border-right: 2px solid #706f7b;\n}\n\n.detail-section {\n  padding: 10rem;\n}\n@media (max-width: 1150px) {\n  .detail-section {\n    padding: 6rem;\n  }\n}\n@media (max-width: 800px) {\n  .detail-section {\n    padding: 1rem;\n  }\n}\n.detail-section__btn {\n  background-color: #f5272b;\n  padding: 1rem 4rem;\n  border-radius: 0.3rem;\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.35);\n  transition: all 0.3s;\n  border: 2px solid #f5272b;\n  font-size: 1.4rem;\n  cursor: pointer;\n  text-align: center;\n}\n.detail-section__btn:hover {\n  box-shadow: 0 10px 15px 0 rgba(255, 83, 48, 0.6);\n  background-color: #fa4226;\n}\n.detail-section__btn a {\n  text-decoration: none;\n  color: white;\n  font-weight: 700;\n}","// background colors\n$bg-gray: #f8f8f8;\n$bg-white: #ffffff;\n\n// text color\n$text-black: #010103;\n$text-orange: #f5272b;\n$btn-black: #161616;\n$text-gray: #706f7b;\n","// font family\n$titles-font: \"Poppins\", sans-serif;\n$text-font: \"Rubik\", sans-serif;\n\n// sizes\n$h1-size: 5.2rem;\n$h2-size: 4.2rem;\n$h3-size: 2.4rem;\n$h4-size: 2.2rem;\n$p-size: 1.6rem;\n$input-size: 1.4rem;\n","@use \"../global/\" as *;\n\n.navbar {\n  max-width: 133rem;\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2.7rem 2rem;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  background-color: transparent;\n  z-index: 999;\n  margin: 0 auto;\n\n  &__img {\n    width: 16.5rem;\n    img {\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  &__links {\n    display: flex;\n    list-style: none;\n    gap: 2.1rem;\n\n    a {\n      font-size: $p-size;\n      font-family: $text-font;\n      font-weight: 500;\n      color: $text-black;\n      text-decoration: none;\n      cursor: pointer;\n      transition: all 0.3s;\n\n      &:hover {\n        color: $text-orange;\n      }\n    }\n\n    @media (max-width: 1000px) {\n      display: none;\n    }\n  }\n\n  &__buttons {\n    display: flex;\n    gap: 2.5rem;\n    font-size: $p-size;\n    font-family: $text-font;\n    font-weight: 500;\n    align-items: center;\n\n    @media (max-width: 1000px) {\n      display: none;\n    }\n\n    &__sign-in {\n      color: $text-black;\n      cursor: pointer;\n      transition: all 0.3s;\n\n      &:hover {\n        color: $text-orange;\n      }\n    }\n\n    &__register {\n      background-color: $text-orange;\n      color: white;\n      padding: 1rem 2rem;\n      border-radius: 3px;\n      box-shadow: 0 10px 15px 0 rgb(255 83 48 / 35%);\n      transition: all 0.3s;\n\n      &:hover {\n        box-shadow: 0 10px 15px 0 rgb(255 83 48 / 50%);\n        background-color: #fa4226;\n      }\n    }\n\n    a {\n      text-decoration: none;\n    }\n  }\n}\n\n//  mobile nav\n\n.mobile-hamb {\n  font-size: 2.8rem;\n  display: flex;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  &:hover {\n    color: $text-orange;\n  }\n\n  @media (min-width: 1000px) {\n    display: none;\n  }\n}\n\n.mobile-navbar {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: -100%;\n  background-color: $bg-white;\n  z-index: 999999;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.5s ease-in-out;\n\n  &__close {\n    font-size: 3rem;\n    position: absolute;\n    top: 3.5rem;\n    right: 3.5rem;\n    cursor: pointer;\n    transition: all 0.3s;\n\n    &:hover {\n      color: $text-orange;\n    }\n  }\n\n  &__links {\n    display: flex;\n    flex-direction: column;\n    list-style: none;\n    font-size: 2.3rem;\n    gap: 3rem;\n    text-align: center;\n\n    li {\n      a {\n        text-decoration: none;\n        color: $text-black;\n        font-weight: 500;\n        transition: all 0.3s;\n\n        &:hover {\n          color: $text-orange;\n        }\n      }\n    }\n  }\n  .sign_in {\n    background-color: #fa4226;\n    padding: 6px;\n    color: #fff;\n    font-weight: 600;\n    text-decoration: none;\n    border-radius: 4px;\n  }\n}\n\n.open-nav {\n  left: 0;\n}\n","@use \"../global\" as *;\n\n.hero-section {\n  width: 100%;\n  background-color: $bg-gray;\n  position: relative;\n  overflow: hidden;\n  padding: 15rem 0px;\n\n  @media (max-width: 1000px) {\n    padding: 12rem 0rem 6rem 0rem;\n  }\n}\n\n.bg-shape {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 0;\n\n  @media (max-width: 800px) {\n    display: none;\n  }\n}\n\n.hero-content {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  position: relative;\n\n  @media (max-width: 800px) {\n    justify-content: center;\n  }\n\n  &__text {\n    display: flex;\n    flex-direction: column;\n    z-index: 3;\n    max-width: 50rem;\n\n    @media (max-width: 800px) {\n      text-align: center;\n      align-items: center;\n    }\n\n    h4 {\n      font-size: $h4-size;\n      font-family: $text-font;\n      color: $text-black;\n    }\n\n    h1 {\n      font-size: $h1-size;\n      font-family: $titles-font;\n      font-weight: 700;\n      color: $text-black;\n      line-height: 1.2;\n      margin-top: 1rem;\n      margin-bottom: 2.3rem;\n\n      span {\n        color: $text-orange;\n      }\n    }\n\n    p {\n      font-size: $p-size;\n      font-family: $text-font;\n      line-height: 1.6;\n      color: $text-gray;\n      margin-bottom: 4rem;\n    }\n\n    &__btns {\n      display: flex;\n      gap: 2rem;\n      font-size: $p-size;\n      font-family: $text-font;\n\n      @media (max-width: 450px) {\n        flex-direction: column;\n      }\n\n      a {\n        text-decoration: none;\n        color: white;\n        font-weight: 700;\n      }\n\n      &__book-ride {\n        background-color: $text-orange;\n        padding: 1.8rem 3rem;\n        border-radius: 0.3rem;\n        box-shadow: 0 10px 15px 0 rgb(255 83 48 / 35%);\n        transition: all 0.3s;\n        border: 2px solid $text-orange;\n\n        @media (max-width: 450px) {\n          padding: 1.8rem 8rem;\n        }\n\n        &:hover {\n          box-shadow: 0 10px 15px 0 rgb(255 83 48 / 60%);\n          background-color: #fa4226;\n        }\n      }\n\n      &__learn-more {\n        background-color: $text-black;\n        padding: 1.8rem 3rem;\n        border-radius: 0.3rem;\n        border: 2px solid $text-black;\n        transition: all 0.3s;\n\n        &:hover {\n          background-color: transparent;\n          color: $text-black;\n        }\n      }\n    }\n  }\n\n  &__car-img {\n    z-index: 2;\n    position: absolute;\n    right: 0;\n    width: 60%;\n\n    @media (max-width: 800px) {\n      display: none;\n    }\n  }\n}\n\n.scroll-up {\n  position: fixed;\n  font-size: 2.5rem;\n  color: white;\n  background-color: $text-orange;\n  border: 3px solid white;\n  width: 2rem;\n  height: 2rem;\n  bottom: 5rem;\n  right: 5rem;\n  z-index: 20;\n  display: none;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  padding: 2rem;\n  cursor: pointer;\n}\n\n.show-scroll {\n  display: flex;\n}\n","@use \"../global\" as *;\n\n.book-section {\n  position: relative;\n\n  background: linear-gradient(to bottom, $bg-gray 20%, $bg-white 80%);\n}\n\n.book-content {\n  margin: 0 auto;\n  margin-bottom: 10rem;\n\n  &__box {\n    background-color: $bg-white;\n    width: 100%;\n    padding: 4rem 4.5rem 5rem 5.5rem;\n    box-shadow: 0 10px 20px 0 rgb(0 0 0 / 10%);\n    height: auto;\n    position: relative;\n    z-index: 4;\n    color: white;\n    border-radius: 5px;\n    background-image: url(\"../../images/book-car/book-bg.png\");\n    background-position: center center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    display: flex;\n    flex-direction: column;\n    color: $text-black;\n\n    @media (max-width: 400px) {\n      padding: 4rem 2.5rem 5rem 2.5rem;\n    }\n\n    &__checkbox-group {\n      display: flex;\n      gap: 2rem;\n      width: 100%;\n      margin: 4px 0px;\n      justify-content: flex-end;\n      div {\n        display: flex;\n        align-items: center;\n\n        p {\n          color: #777777;\n          font-size: 14px;\n          font-weight: 500;\n          margin-top: 1rem;\n          margin-bottom: 1rem;\n          @media (max-width: 400px) {\n            font-size: 12px;\n          }\n        }\n      }\n    }\n\n    h2 {\n      font-size: $h3-size;\n      font-weight: 700;\n      // margin-bottom: 2.7rem;\n    }\n\n    .error-modal {\n      color: #fe3516;\n    }\n\n    .box-form {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      grid-template-rows: auto auto auto;\n      gap: 2rem;\n\n      b {\n        color: $text-orange;\n      }\n\n      @media (max-width: 1000px) {\n        grid-template-columns: 1fr;\n      }\n\n      @media (max-width: 630px) {\n        grid-template-columns: 1fr;\n      }\n\n      &__car-type {\n        display: flex;\n        flex-direction: column;\n\n        &[id=\"1\"] {\n          grid-column: 1 / span 2;\n          @media (max-width: 1000px) {\n            grid-column: 1;\n          }\n        }\n\n        &:last-child {\n          grid-column: 2;\n          @media (max-width: 1000px) {\n            grid-column: 1;\n          }\n        }\n\n        label {\n          font-size: $p-size;\n          font-weight: 600;\n          margin-bottom: 1.2rem;\n\n          i {\n            color: $text-orange;\n          }\n        }\n\n        select {\n          font-size: 1.5rem;\n          color: #ababab;\n          font-family: $text-font;\n          border: 1px solid #ccd7e6;\n          border-radius: 3px;\n          font-weight: 400;\n          padding: 1.2rem 1.3rem;\n          outline: none;\n        }\n      }\n\n      &__car-time {\n        display: flex;\n        flex-direction: column;\n        position: relative;\n\n        // input {\n        //   outline: none;\n        //   color: #878585;\n        //   padding-right: 3rem;\n        //   border: 1px solid #ccd7e6;\n        // }\n\n        label {\n          font-size: 1.6rem;\n          font-weight: 600;\n          margin-bottom: 1.2rem;\n\n          i {\n            color: $text-orange;\n          }\n        }\n\n        ::-webkit-datetime-edit {\n          padding: 1.3rem 1.3rem;\n        }\n\n        ::-webkit-calendar-picker-indicator {\n          cursor: pointer;\n          font-size: 1.6rem;\n        }\n      }\n\n      &__book-button {\n        width: 100%;\n        align-items: center;\n        @media (max-width: 630px) {\n          margin-top: 2rem;\n        }\n      }\n    }\n\n    .googlemap_input {\n      font-size: 1.5rem;\n      color: #ababab;\n      font-family: \"Rubik\", sans-serif;\n      border: 1px solid #ccd7e6;\n      border-radius: 3px;\n      font-weight: 400;\n      padding: 1.2rem 1.3rem;\n      outline: none;\n      width: 100%;\n    }\n\n    &__book-button {\n      width: 100%;\n      padding: 1.3rem 1.3rem;\n      height: fit-content;\n      align-self: self-end;\n      border: none;\n      font-family: $text-font;\n      font-size: 1.8rem;\n      font-weight: 500;\n      color: white;\n      background-color: $text-orange;\n      box-shadow: 0 10px 15px rgb(255 83 48 / 35%);\n      cursor: pointer;\n      transition: all 0.3s;\n\n      &:hover {\n        box-shadow: 0 10px 15px rgb(255 83 48 / 55%);\n      }\n    }\n  }\n}\n\n.error-message {\n  color: #721c24;\n  background-color: #f8d7da;\n  border-color: #f5c6cb;\n  padding: 1rem 1.4rem;\n  margin-bottom: 1.8rem;\n  margin-top: -1rem;\n  border: 1px solid transparent;\n  border-radius: 0.8rem;\n  font-size: $p-size;\n  font-weight: 500;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  i {\n    cursor: pointer;\n  }\n}\n\n.booking-done {\n  color: #2a6817;\n  background-color: #c3fabe;\n  border-color: #f5c6cb;\n  padding: 1rem 1.4rem;\n  margin-bottom: 1.8rem;\n  margin-top: -1rem;\n  border: 1px solid transparent;\n  border-radius: 0.8rem;\n  font-size: $p-size;\n  font-weight: 500;\n\n  display: none;\n  justify-content: space-between;\n  align-items: center;\n\n  i {\n    cursor: pointer;\n  }\n}\n\n// modal & overlay\n\n.active-modal {\n  opacity: 1 !important;\n  display: flex !important;\n}\n\n.modal-overlay {\n  opacity: 0;\n  display: none;\n\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  z-index: 999999999;\n  top: 0;\n  right: 0;\n}\n\n.booking-modal {\n  opacity: 0;\n  display: none;\n\n  flex-direction: column;\n  position: fixed;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  z-index: 999999999999;\n  top: 54%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 83rem;\n  height: 100vh;\n  border: 2px solid white;\n  background-color: rgba(255, 255, 255);\n  padding-right: 2px;\n  color: $text-black;\n\n  @media (max-width: 800px) {\n    width: 95%;\n    height: 95%;\n  }\n\n  @media (max-width: 600px) {\n    top: 50%;\n  }\n\n  &__title {\n    display: flex;\n    justify-content: space-between;\n    padding: 1rem 1.5rem;\n    background-color: $text-orange;\n    color: white;\n    align-items: center;\n\n    h2 {\n      font-size: $h3-size;\n      text-transform: uppercase;\n    }\n\n    i {\n      font-size: 2.5rem;\n      color: rgba(255, 255, 255, 0.919);\n      cursor: pointer;\n      transition: all 0.2;\n\n      &:hover {\n        color: white;\n      }\n    }\n  }\n\n  &__message {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    padding: 2rem 3rem;\n    background-color: #ffeae6;\n\n    h4 {\n      font-size: 1.9rem;\n      font-weight: 700;\n      color: $text-orange;\n\n      i {\n        font-size: 2.5rem;\n      }\n    }\n\n    p {\n      font-size: 1.7rem;\n      color: #777777;\n      font-weight: 500;\n      line-height: 1.6;\n    }\n  }\n\n  &__car-info {\n    background-color: white;\n    padding: 3rem 3rem;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    border-bottom: 1px solid #7777779f;\n\n    @media (max-width: 650px) {\n      grid-template-columns: 1fr;\n      text-align: center;\n    }\n\n    &__dates {\n      display: flex;\n      flex-direction: column;\n      gap: 2rem;\n\n      h5 {\n        font-size: 1.8rem;\n        color: $text-orange;\n      }\n\n      span {\n        display: flex;\n        gap: 1rem;\n\n        @media (max-width: 650px) {\n          grid-template-columns: 1fr;\n          text-align: center;\n          justify-content: center;\n        }\n\n        i {\n          font-size: 1.8rem;\n          padding-top: 0.2rem;\n          color: #777777;\n\n          @media (max-width: 650px) {\n            display: none;\n          }\n        }\n\n        h6 {\n          font-size: 1.5rem;\n          margin-bottom: 0.2rem;\n        }\n\n        p {\n          font-size: $p-size;\n          color: #777777;\n        }\n        span {\n          color: #0075ff;\n          font-size: $p-size;\n          cursor: pointer;\n          font-weight: 500;\n\n          align-items: center;\n\n          i {\n            color: #0075ff;\n          }\n        }\n      }\n    }\n\n    &__model {\n      display: flex;\n      flex-direction: column;\n      gap: 3rem;\n\n      @media (max-width: 650px) {\n        margin-top: 3.5rem;\n      }\n\n      h5 {\n        font-size: 1.8rem;\n        color: $text-orange;\n\n        span {\n          color: $text-black;\n        }\n      }\n\n      img {\n        width: 100%;\n        height: auto;\n      }\n    }\n  }\n\n  &__person-info {\n    padding: 3rem 3rem;\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n\n    h4 {\n      font-size: 1.8rem;\n      text-transform: uppercase;\n      color: $text-orange;\n      margin-bottom: 2rem;\n    }\n  }\n}\n\n.price_note {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n  justify-content: start;\n  margin-top: 1rem;\n  font-size: 11px;\n}\n\n.out_of_town_note {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n  margin-top: 1rem;\n  font-size: 11px;\n}\n\n.input-time {\n  text-align: center;\n  width: 8rem;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.info-form {\n  display: flex;\n  flex-direction: column;\n\n  &__checkbox {\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n    font-size: $p-size;\n    color: #565454;\n    margin-top: 2rem;\n    margin-bottom: 1rem;\n\n    input {\n      width: 1.6rem;\n      height: 1.6rem;\n    }\n  }\n\n  &__1col {\n    grid-template-columns: 1fr !important;\n  }\n\n  &__2col,\n  &__1col {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 2rem;\n    padding: 1rem 0;\n\n    @media (max-width: 650px) {\n      grid-template-columns: 1fr;\n    }\n\n    span {\n      display: flex;\n      flex-direction: column;\n      gap: 0.4rem;\n\n      label {\n        font-size: $p-size;\n        font-weight: 500;\n        color: #777777;\n\n        b {\n          color: $text-orange;\n        }\n      }\n\n      input,\n      textarea {\n        padding: 14px 15px;\n        background-color: #dbdbdb;\n        color: #555;\n        font-size: 1.5rem;\n        font-weight: 500;\n        outline: none;\n        border: none;\n      }\n\n      select {\n        padding: 14px 15px;\n        background-color: #dbdbdb;\n        color: #555;\n        font-size: 1.5rem;\n        font-weight: 500;\n        outline: none;\n        border: none;\n        option {\n          background-color: #fff;\n        }\n      }\n\n      p {\n        color: #fe3516;\n      }\n    }\n  }\n}\n\n.reserve-button {\n  background-color: transparent;\n  margin: 0 -3rem;\n  padding: 3rem;\n  text-align: right;\n\n  @media (max-width: 650px) {\n    text-align: center;\n  }\n\n  button {\n    font-size: $h3-size;\n    color: white;\n    font-weight: 700;\n    background-color: $text-orange;\n    border: 1px solid #fe3516;\n    padding: 1.2rem 2rem;\n    cursor: pointer;\n    transition: all 0.2s;\n\n    &:hover {\n      background-color: #fe3516;\n    }\n  }\n}\n\n.reserve-button__disabled {\n  margin: 0 -3rem;\n  padding: 3rem;\n  text-align: right;\n\n  @media (max-width: 650px) {\n    text-align: center;\n  }\n\n  button {\n    font-size: $h3-size;\n    color: white;\n    font-weight: 700;\n    background-color: #ababab;\n    border: 1px solid #ababab;\n    padding: 1.2rem 2rem;\n    cursor: pointer;\n    transition: all 0.2s;\n  }\n}\n\n.dates-div {\n  display: flex;\n  flex-direction: column;\n  gap: 3.2rem;\n}\n\n.price_estimation {\n  color: #f5272b;\n  font-weight: 600;\n}\n\n.aditional_and_prices {\n  padding: 3rem;\n  // h5 {\n  //   font-size: 1.8rem;\n  //   color: $text-orange;\n  // }\n}\n.aditional_input {\n  background-color: #dbdbdb;\n  color: #555;\n  font-size: 1.5rem;\n  font-weight: 500;\n  outline: none;\n  border: none;\n  text-align: center;\n  width: 35px;\n}\n\n.map-modal {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n\n  &.open {\n    display: block;\n  }\n\n  .modal-content {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: white;\n    padding: 6px;\n    border-radius: 6px;\n    width: 600px;\n\n    @media (max-width: 650px) {\n      width: 90vw;\n    }\n  }\n\n  .map-container {\n    width: 100%;\n    height: 380px;\n  }\n\n  .button-container {\n    margin-top: 10px;\n    padding: 8px 0;\n    display: flex;\n    gap: 12px;\n\n    button {\n      padding: 8px 12px;\n      border: none;\n      font-size: 18px;\n      color: white;\n      border-radius: 2px;\n      cursor: pointer;\n      transition: background-color 0.2s ease-in-out;\n\n      @media (max-width: 650px) {\n        font-size: 16px;\n      }\n\n      &.save {\n        background-color: #f5272b;\n      }\n\n      &.close {\n        background-color: #000000;\n      }\n\n      &:hover {\n        opacity: 0.8;\n      }\n    }\n  }\n\n  .address-info {\n    padding: 8px;\n    background-color: #f8f8f8;\n    border-radius: 2px;\n    font-size: 14px;\n  }\n}\n","@use \"../global\" as *;\n\n.plan-section {\n  background-color: $bg-white;\n  padding: 5.3rem 0;\n}\n\n.plan-container {\n  display: flex;\n  flex-direction: column;\n\n  &__title {\n    margin: 0 auto;\n    text-align: center;\n    color: $text-black;\n\n    h3 {\n      font-size: $h3-size;\n      font-family: $text-font;\n      font-weight: 500;\n    }\n\n    h2 {\n      font-size: $h2-size;\n      font-family: $titles-font;\n      margin: 1.3rem 0 3rem 0;\n    }\n  }\n\n  &__boxes {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-template-rows: auto;\n    margin-top: 3.7rem;\n    padding: 0 3rem;\n\n    @media (max-width: 1021px) {\n      grid-template-columns: 1fr 1fr;\n      row-gap: 2rem;\n    }\n\n    @media (max-width: 800px) {\n      grid-template-columns: 1fr;\n      margin-top: 1rem;\n    }\n\n    &__box {\n      text-align: center;\n      padding: 1rem 6rem;\n\n      @media (max-width: 500px) {\n        padding: 1rem 1rem;\n      }\n\n      img {\n        width: 17rem;\n        height: auto;\n      }\n\n      h3 {\n        font-size: $h3-size;\n        margin-bottom: 1rem;\n      }\n\n      p {\n        font-size: $p-size;\n        font-family: $text-font;\n        color: $text-gray;\n        line-height: 1.43;\n      }\n    }\n  }\n}\n","@use \"../global\" as *;\n\n.pick-section {\n  padding: 10rem 0;\n}\n\n.pick-container {\n  display: flex;\n  flex-direction: column;\n\n  &__title {\n    margin: 0 auto;\n    text-align: center;\n    color: $text-black;\n    max-width: 50rem;\n    margin-bottom: 5rem;\n\n    p {\n      font-size: $p-size;\n      font-family: $text-font;\n      color: $text-gray;\n      line-height: 1.5;\n    }\n\n    h3 {\n      font-size: $h3-size;\n      font-family: $text-font;\n      font-weight: 500;\n    }\n\n    h2 {\n      font-size: $h2-size;\n      font-family: $titles-font;\n      margin: 0.5rem 0 1rem 0;\n    }\n  }\n\n  &__car-content {\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n\n    @media (max-width: 1050px) {\n      flex-direction: column;\n      gap: 5rem;\n    }\n  }\n}\n\n.pick-box {\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  margin-bottom: 4px;\n\n  button {\n    font-size: 2rem;\n    font-family: $titles-font;\n    font-weight: 600;\n    border: none;\n    cursor: pointer;\n    padding: 1.5rem 2.5rem;\n    background-color: #e9e9e9;\n    transition: all 0.2s;\n    text-align: left;\n\n    &:hover {\n      background-color: $text-orange;\n      color: white;\n    }\n  }\n}\n\n.pick-car {\n  width: 50rem;\n  position: relative;\n\n  @media (max-width: 700px) {\n    width: 100%;\n  }\n\n  img {\n    width: 100%;\n    margin-top: 6rem;\n  }\n}\n\n.pick-description {\n  width: 25rem;\n\n  &__price {\n    width: 100%;\n    background-color: $text-orange;\n    font-size: 1.8rem;\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n    color: white;\n    padding: 0.3rem 1.9rem;\n\n    span {\n      font-size: 2.5rem;\n      font-weight: 700;\n    }\n  }\n\n  &__table {\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-template-rows: auto;\n    font-size: 1.4rem;\n    // font-family: $text-font;\n\n    &__col {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      text-align: center;\n      grid-template-rows: auto;\n      padding: 0.9rem 0.5rem;\n      border-bottom: 2px solid #706f7b;\n      border-right: 2px solid #706f7b;\n      border-left: 2px solid #706f7b;\n\n      span:nth-child(1) {\n        border-right: 2px solid #706f7b;\n      }\n    }\n  }\n}\n\n.cta-btn {\n  font-size: 2rem;\n  text-transform: uppercase;\n  text-decoration: none;\n  font-weight: 600;\n  color: white;\n  font-family: $titles-font;\n  background-color: $text-orange;\n  padding: 1rem 1rem;\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  margin-top: 1.4rem;\n  transition: all 0.3s;\n  box-shadow: 6px 6px 0 #efe9e9;\n\n  &:hover {\n    background-color: #e9381d;\n  }\n}\n\n.box-cars {\n  gap: 11rem;\n  display: flex;\n  justify-content: space-between;\n\n  @media (max-width: 1200px) {\n    gap: 2rem;\n  }\n\n  @media (max-width: 700px) {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 5rem;\n  }\n}\n\n.colored-button {\n  background-color: $text-orange !important;\n  color: white;\n}\n\n// spiner\n.loader {\n  width: 48px;\n  height: 48px;\n  border: 5px solid #00000042;\n  border-bottom-color: #ff3d00;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  top: 40%;\n  right: 43%;\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n","@use \"../global\" as *;\n\n.banner-section {\n  width: 100%;\n  height: auto;\n  display: flex;\n  background-color: #1b2335;\n  margin: 8rem 0;\n  padding: 6rem 0;\n  text-align: center;\n}\n\n.banner-content {\n  color: white;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n\n  &__text {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n\n    h2 {\n      font-size: $h1-size;\n      line-height: 1.3;\n\n      @media (max-width: 550px) {\n        font-size: $h2-size;\n      }\n    }\n\n    p {\n      font-size: $h3-size;\n\n      @media (max-width: 550px) {\n        font-size: 2rem;\n      }\n    }\n\n    span {\n      color: $text-orange;\n      font-weight: 500;\n    }\n  }\n}\n","@use \"../global\" as *;\n\n.choose-section {\n  background-color: white;\n  padding: 2rem 0 10rem 0;\n  background-image: url(\"../../images/chooseUs/bg.png\");\n  background-position: -225px 255px;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.choose-container {\n  display: flex;\n  flex-direction: column;\n\n  &__img {\n    width: 90%;\n    height: auto;\n    margin: 0 auto;\n\n    @media (max-width: 550px) {\n      width: 100%;\n    }\n  }\n}\n\n.text-container {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 3rem;\n  width: 100%;\n\n  @media (max-width: 1000px) {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 5.5rem;\n  }\n\n  &__left {\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    max-width: 50rem;\n    color: $text-black;\n\n    @media (max-width: 1000px) {\n      align-items: center;\n      text-align: center;\n    }\n\n    h4 {\n      font-size: $h4-size;\n      margin-bottom: 0.7rem;\n      font-weight: 600;\n      font-family: $text-font;\n    }\n\n    h2 {\n      font-size: $h2-size;\n      line-height: 1.2;\n      margin-bottom: 2rem;\n    }\n\n    p {\n      font-size: $p-size;\n      font-family: $text-font;\n      line-height: 1.5;\n      color: $text-gray;\n      margin-bottom: 3.3rem;\n    }\n\n    a {\n      text-decoration: none;\n      color: white;\n      font-weight: 700;\n      background-color: #f5272b;\n      padding: 1.5rem 2.5rem;\n      border-radius: 0.3rem;\n      box-shadow: 0 10px 15px 0 rgb(255 83 48 / 35%);\n      transition: all 0.3s;\n      border: 2px solid #f5272b;\n      font-size: $p-size;\n      width: fit-content;\n\n      &:hover {\n        box-shadow: 0 10px 15px 0 rgb(255 83 48 / 60%);\n        background-color: #fa4226;\n      }\n    }\n  }\n\n  &__right {\n    display: flex;\n    flex-direction: column;\n    gap: 4.5rem;\n    max-width: 44rem;\n\n    &__box {\n      display: flex;\n\n      @media (max-width: 550px) {\n        flex-direction: column;\n        align-items: center;\n      }\n\n      img {\n        width: 11rem;\n        height: 11rem;\n        margin-right: 1.1rem;\n      }\n\n      &__text {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        justify-content: center;\n\n        h4 {\n          font-size: $h3-size;\n        }\n\n        p {\n          font-size: $p-size;\n          color: $text-gray;\n          font-family: $text-font;\n          line-height: 1.3;\n        }\n      }\n    }\n  }\n}\n","@use \"../global\" as *;\n\n.testimonials-section {\n  background-color: $bg-gray;\n  padding: 10rem 0;\n  color: $text-black;\n}\n\n.testimonials-content {\n  display: flex;\n  flex-direction: column;\n\n  &__title {\n    display: flex;\n    flex-direction: column;\n    margin: 0 auto;\n    text-align: center;\n    margin-bottom: 5rem;\n    max-width: 700px;\n\n    h4 {\n      font-size: $h4-size;\n      font-family: $text-font;\n      font-weight: 500;\n    }\n\n    h2 {\n      font-size: $h2-size;\n      margin-bottom: 1.4rem;\n    }\n\n    p {\n      font-size: $p-size;\n      font-family: $text-font;\n      color: $text-gray;\n      line-height: 1.4;\n    }\n  }\n}\n\n.all-testimonials {\n  display: flex;\n  gap: 3rem;\n  width: 100%;\n  justify-content: flex-start;\n  padding: 3rem;\n  overflow-x: scroll;\n\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $text-orange;\n    border-radius: 10px;\n  }\n\n  &__box {\n    background-color: white;\n    box-shadow: 0 20px 40px 0 rgb(0 0 0 / 8%);\n    width: 30%;\n    padding: 2rem;\n    position: relative;\n    flex-shrink: 0;\n    scroll-snap-align: center;\n    border-radius: 10px;\n    white-space: normal;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    @media (max-width: 1000px) {\n      width: 90%;\n      padding: 4rem;\n    }\n\n    p {\n      font-size: 1.5rem;\n      font-weight: 500;\n      max-height: 250px;\n      overflow-y: auto;\n    }\n\n    .rating {\n      color: #ffcc00;\n      display: flex;\n      gap: 2px;\n      margin-bottom: 1.5rem;\n      justify-content: space-between;\n      align-items: center;\n\n      i {\n        font-size: 2rem;\n      }\n      .left {\n        display: flex;\n        align-items: center;\n        p {\n          color: $text-black;\n          margin-right: 1rem;\n        }\n      }\n      img {\n        width: 2rem;\n        height: auto;\n      }\n    }\n\n    &__name {\n      display: flex;\n\n      &__profile {\n        display: flex;\n        gap: 2rem;\n        align-items: center;\n        margin-top: 3rem;\n\n        img {\n          width: 7rem;\n          height: 7rem;\n          border-radius: 50%;\n        }\n\n        h4 {\n          font-size: 1.8rem;\n        }\n\n        p {\n          font-size: $p-size;\n          font-family: $text-font;\n          font-weight: 400;\n        }\n      }\n    }\n  }\n}\n\n.quotes-icon {\n  font-size: 6.2rem;\n  color: $text-orange;\n  position: absolute;\n  bottom: 33px;\n  right: 60px;\n\n  @media (max-width: 470px) {\n    display: none;\n  }\n}\n\n@media (max-width: 600px) {\n  .testimonials-section {\n    padding: 5rem 0;\n  }\n\n  .all-testimonials {\n    padding: 0rem;\n  }\n\n  .all-testimonials__box {\n    width: 85%;\n    padding: 3rem;\n  }\n}\n\n.footer {\n  background-color: white;\n  width: fit-content;\n  margin: auto;\n  padding: 3rem 5rem;\n  margin-top: 3rem;\n  border-radius: 1rem;\n  text-align: center;\n\n  .google {\n    display: flex;\n    align-items: center;\n\n    img {\n      width: 3rem;\n      height: auto;\n      margin-right: 1rem;\n    }\n\n    p {\n      font-size: 2rem;\n      font-weight: 700;\n      color: $text-black;\n    }\n  }\n  .rating {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    span {\n      font-size: 1.5rem;\n    }\n    i {\n      color: #ffcc00;\n      font-size: 1.5rem;\n    }\n    margin-bottom: 8px;\n    margin-top: 4px;\n  }\n}\n\n.all-testimonials::-webkit-scrollbar {\n  display: none;\n}\n\n.all-testimonials {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n","@use \"../global\" as *;\n\n.faq-section {\n  background-image: url(\"../../images/faq/veloz.png\");\n  padding: 10rem 0;\n  background-size: auto;\n  background-repeat: no-repeat;\n  background-position: 0 70%;\n}\n\n.faq-content {\n  display: flex;\n  flex-direction: column;\n  color: $text-black;\n\n  &__title {\n    display: flex;\n    flex-direction: column;\n    margin: 0 auto;\n    text-align: center;\n    max-width: 80rem;\n    line-height: 1.5;\n\n    h5 {\n      font-size: $h4-size;\n    }\n\n    h2 {\n      font-size: $h2-size;\n      margin-bottom: 1.7rem;\n    }\n\n    p {\n      font-size: $p-size;\n      color: $text-gray;\n    }\n  }\n}\n\n.all-questions {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 7rem;\n}\n\n.faq-box {\n  display: flex;\n  flex-direction: column;\n  color: $text-black;\n  background-color: white;\n  box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.1);\n\n  width: 80rem;\n  cursor: pointer;\n\n  @media (max-width: 850px) {\n    width: 100%;\n  }\n\n  &__question {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: 0 3px 6px 0 rgb(0 0 0 / 10%);\n    padding: 1.8rem 4.5rem;\n    transition: 0.15s ease;\n\n    p {\n      font-size: 1.8rem;\n      font-weight: 500;\n    }\n\n    i {\n      font-size: 2rem;\n    }\n  }\n\n  &__answer {\n    font-size: $p-size;\n    font-family: $text-font;\n    color: $text-gray;\n    line-height: 1.7;\n    max-height: 0;\n    overflow: hidden;\n    transition: 0.4s ease;\n    padding: 0 4.5rem;\n  }\n}\n\n.active-answer {\n  max-height: 20rem;\n  padding: 2.8rem 4.5rem;\n  transition: 0.4s ease;\n\n  @media (max-width: 550px) {\n    max-height: 30rem;\n  }\n\n  @media (max-width: 420px) {\n    max-height: 55rem;\n  }\n}\n\n.active-question {\n  background-color: $text-orange;\n  color: white;\n  box-shadow: 0 10px 15px 0 rgb(255 83 48 / 35%);\n}\n","@use \"../global\" as *;\n\n.download-section {\n  background-image: url(\"../../images/banners/bg02.png\");\n  background-color: $bg-gray;\n  background-position: top center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 100%;\n  height: auto;\n  padding: 10rem 0;\n\n  @media (max-width: 700px) {\n    background-image: none;\n  }\n}\n\n.download-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  max-width: 55rem;\n  text-align: left;\n\n  @media (max-width: 700px) {\n    text-align: center;\n    margin: 0 auto;\n  }\n\n  h2 {\n    font-size: $h2-size;\n    color: $text-black;\n  }\n\n  p {\n    font-size: $p-size;\n    color: $text-gray;\n    font-family: $text-font;\n    line-height: 1.5;\n  }\n\n  &__btns {\n    display: flex;\n    gap: 3rem;\n    margin-top: 2rem;\n\n    @media (max-width: 700px) {\n      justify-content: center;\n    }\n\n    @media (max-width: 550px) {\n      flex-direction: column;\n      align-items: center;\n    }\n\n    img {\n      width: 40%;\n      cursor: pointer;\n\n      @media (max-width: 550px) {\n        width: 22rem;\n      }\n    }\n  }\n}\n","@use \"../global\" as *;\n\nfooter {\n  background-color: $bg-white;\n  padding: 10rem 0;\n}\n\n.footer-content {\n  display: grid;\n  color: #010103;\n  grid-template-columns: 40fr 30fr 30fr;\n  gap: 8rem;\n  justify-content: center;\n  text-align: left;\n  color: $text-black;\n\n  @media (max-width: 1100px) {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  @media (max-width: 650px) {\n    grid-template-columns: 1fr;\n  }\n\n  &__1 {\n    list-style: none;\n    // max-width: 30rem;\n\n    @media (max-width: 650px) {\n      text-align: center;\n    }\n\n    li {\n      a {\n        text-decoration: none;\n        color: $text-black;\n        transition: all 0.2s;\n\n        &:hover {\n          color: $text-orange;\n        }\n      }\n\n      &:nth-child(1) {\n        font-size: $h3-size;\n        margin-bottom: 1.5rem;\n\n        span {\n          font-weight: 700;\n        }\n      }\n\n      &:nth-child(2) {\n        font-size: $p-size;\n        color: $text-gray;\n        line-height: 1.7;\n        margin-bottom: 3rem;\n      }\n\n      &:nth-child(3),\n      &:nth-child(4),\n      &:nth-child(5) {\n        font-size: $p-size;\n        font-family: $text-font;\n        font-weight: 500;\n        margin-bottom: 1rem;\n      }\n    }\n  }\n\n  &__2 {\n    list-style: none;\n\n    @media (max-width: 650px) {\n      text-align: center;\n    }\n\n    a {\n      text-decoration: none;\n      color: $text-black;\n      transition: all 0.2s;\n\n      &:hover {\n        color: $text-orange;\n      }\n    }\n\n    li {\n      font-size: $p-size;\n      margin-bottom: 1rem;\n\n      &:nth-child(1) {\n        font-size: $h3-size;\n        font-weight: 700;\n        text-transform: uppercase;\n        font-family: $titles-font;\n        cursor: auto;\n      }\n    }\n\n    input {\n      font-family: $text-font;\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 26px;\n      background-color: #ececec;\n      border-width: 1px;\n      border-color: transparent;\n      padding: 10px 60px;\n      outline: none;\n      margin-top: 1rem;\n\n      @media (max-width: 1100px) {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.submit-email {\n  text-decoration: none;\n  color: white;\n  font-weight: 700;\n  background-color: #f5272b;\n  padding: 1.5rem 2.5rem;\n  border-radius: 0.3rem;\n  box-shadow: 0 10px 15px 0 rgb(255 83 48 / 25%);\n  transition: all 0.3s;\n  border: 2px solid #f5272b;\n  font-size: 1.6rem;\n  width: fit-content;\n  cursor: pointer;\n  width: 100%;\n\n  &:hover {\n    box-shadow: 0 10px 15px 0 rgb(255 83 48 / 40%);\n    background-color: #fa4226;\n  }\n}\n","@use \"../global\" as *;\n\n// hero for all pages\n.hero-pages {\n  width: 100%;\n  height: 41rem;\n  background-image: url(\"../../images/hero/camry.webp\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: relative;\n\n  &__overlay {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: rgba(255, 255, 255, 0.92);\n  }\n\n  &__text {\n    display: flex;\n    flex-direction: column;\n    z-index: 3;\n    position: relative;\n    width: 100%;\n    height: 41rem;\n    justify-content: center;\n    color: $text-black;\n\n    h3 {\n      font-size: 3.6rem;\n      margin-bottom: 0.5rem;\n    }\n\n    p {\n      font-size: $p-size;\n      font-weight: 600;\n\n      a {\n        color: $text-black;\n        text-decoration: none;\n        transition: all 0.2s;\n\n        &:hover {\n          color: $text-orange;\n        }\n      }\n    }\n  }\n}\n\n// about scss\n.about-main {\n  margin: 10rem auto;\n  display: flex;\n  gap: 5rem;\n  max-width: 90rem;\n  align-items: center;\n\n  @media (max-width: 960px) {\n    display: grid;\n    grid-template-columns: 1fr;\n    text-align: center;\n    max-width: 49rem;\n  }\n\n  @media (max-width: 520px) {\n    max-width: 100%;\n  }\n\n  &__img {\n    width: 43rem;\n    height: 43rem;\n\n    @media (max-width: 960px) {\n      margin: 0 auto;\n    }\n\n    @media (max-width: 520px) {\n      width: 100%;\n      height: auto;\n    }\n  }\n\n  &__text {\n    color: $text-black;\n    display: flex;\n    flex-direction: column;\n\n    h3 {\n      font-size: $h4-size;\n      font-family: $text-font;\n      font-weight: 500;\n      margin-bottom: 1rem;\n    }\n\n    h2 {\n      font-size: $h2-size;\n      line-height: 1.2;\n    }\n\n    p {\n      font-size: $p-size;\n      color: $text-gray;\n      font-family: $text-font;\n      line-height: 1.5;\n      margin-top: 2rem;\n      margin-bottom: 4rem;\n    }\n\n    &__icons {\n      display: grid;\n\n      grid-template-columns: 1fr 1fr 1fr;\n      gap: 4rem;\n\n      @media (max-width: 520px) {\n        grid-template-columns: 1fr;\n        margin: 0 auto;\n        gap: 0;\n\n        p {\n          margin-top: 0;\n        }\n      }\n\n      &__box {\n        display: flex;\n        flex-direction: column;\n\n        @media (max-width: 520px) {\n          align-items: center;\n        }\n\n        .last-fk {\n          width: 5rem;\n        }\n\n        img {\n          width: 7rem;\n        }\n\n        span {\n          display: flex;\n          align-items: center;\n          gap: 1rem;\n\n          @media (max-width: 520px) {\n            text-align: center;\n            flex-direction: column;\n          }\n\n          h4 {\n            font-size: 4.6rem;\n          }\n        }\n      }\n    }\n  }\n}\n.close-icon {\n  background-color: white;\n  padding: 8px;\n  border: 1px solid $text-gray;\n  color: $text-black;\n}\n\n.book-banner {\n  display: flex;\n  width: 100%;\n  height: 20rem;\n  background-image: url(\"../../images/banners/book-banner.png\");\n  position: relative;\n  margin-top: 7rem;\n\n  @media (max-width: 750px) {\n    height: fit-content;\n    padding: 1rem 0;\n  }\n\n  &__overlay {\n    background-color: #1b2335;\n    opacity: 0.89;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n  }\n}\n\n.text-content {\n  color: white;\n  z-index: 5;\n  position: relative;\n  width: 100%;\n  height: 20rem;\n  display: flex;\n  align-items: center;\n  gap: 5rem;\n\n  @media (max-width: 750px) {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    text-align: center;\n  }\n\n  h2 {\n    font-size: 3.2rem;\n  }\n\n  span {\n    display: flex;\n    font-size: 2.7rem;\n    gap: 1rem;\n    align-items: center;\n    color: $text-orange;\n    white-space: nowrap;\n  }\n}\n\n.about-company-section {\n  margin: 8rem auto 0 auto;\n  padding-bottom: 6rem;\n  max-width: 80rem;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: $text-black;\n\n  &__logo {\n    width: 36rem;\n    margin-bottom: 8rem;\n\n    @media (max-width: 520px) {\n      width: 18rem;\n      margin-bottom: 4rem;\n    }\n  }\n\n  &__subtitle {\n    font-size: $h4-size;\n    font-family: $text-font;\n    font-weight: 500;\n    margin-bottom: 1rem;\n  }\n\n  &__title {\n    font-size: $h2-size;\n    line-height: 1.2;\n    margin-bottom: 2rem;\n  }\n\n  &__description {\n    font-size: $p-size;\n    color: $text-gray;\n    font-family: $text-font;\n    line-height: 1.6;\n  }\n}\n","@use \"../global\" as *;\n\n.models-div {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-rows: auto;\n  gap: 3rem;\n  align-items: center;\n  text-align: center;\n  padding: 10rem 0;\n  width: 110rem;\n  margin: 0 auto;\n\n  @media (max-width: 1150px) {\n    grid-template-columns: 1fr 1fr;\n    width: fit-content;\n  }\n\n  @media (max-width: 800px) {\n    grid-template-columns: 1fr;\n    width: fit-content;\n  }\n\n  &__box {\n    border: 1px solid #d5d5d5;\n    border-radius: 0.3rem;\n    display: flex;\n    width: 35rem;\n    flex-direction: column;\n    justify-content: end;\n    height: 58rem;\n\n    @media (max-width: 400px) {\n      grid-template-columns: 1fr;\n      width: 100%;\n    }\n\n    &__img {\n      border-radius: 0.3rem;\n      overflow: hidden;\n      img {\n        display: block;\n        width: 100%;\n        max-height: 24rem;\n        object-fit: cover;\n      }\n    }\n\n    &__descr {\n      padding: 3rem 3rem;\n      display: flex;\n      flex-direction: column;\n      color: $text-black;\n\n      &__name-price {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        &__name {\n          display: flex;\n          flex-direction: column;\n          text-align: left;\n          gap: 0.5rem;\n\n          p {\n            font-size: $h3-size;\n            font-weight: 700;\n          }\n\n          span {\n            display: flex;\n            gap: 0.4rem;\n\n            i {\n              font-size: 1.4rem;\n              color: #ffc933;\n            }\n          }\n        }\n\n        &__price {\n          display: flex;\n          flex-direction: row;\n          text-align: right;\n\n          h4 {\n            font-size: 2.8rem;\n          }\n\n          p {\n            font-size: $p-size;\n          }\n          i {\n            font-size: 1.4rem;\n            color: #ffc933;\n          }\n        }\n\n        &__details {\n          display: flex;\n          justify-content: space-between;\n          margin-bottom: 2rem;\n          gap: 6px;\n          padding-top: 2.5rem;\n          padding-bottom: 2.5rem;\n          border-bottom: 1px solid #c6c6c6;\n          align-items: center;\n          height: 8.5rem;\n          &__self-prices {\n            width: 50%;\n            display: flex;\n            flex-direction: column;\n            text-align: start;\n            p {\n              color: grey;\n              font-size: 12px;\n            }\n            span {\n              font-size: 20px;\n              font-weight: 700;\n              color: #f5272b;\n            }\n          }\n          &__includes {\n            text-align: start;\n            width: 50%;\n            div {\n              span {\n                color: #010103;\n                font-weight: 600;\n                font-size: 12px;\n              }\n            }\n            p {\n              color: grey;\n            }\n          }\n        }\n\n        &__btn {\n          background-color: #f5272b;\n          padding: 1.8rem 3rem;\n          border-radius: 0.3rem;\n          box-shadow: 0 10px 15px 0 rgb(255 83 48 / 35%);\n          transition: all 0.3s;\n          border: 2px solid #f5272b;\n          font-size: 1.8rem;\n          cursor: pointer;\n\n          &:hover {\n            box-shadow: 0 10px 15px 0 rgb(255 83 48 / 60%);\n            background-color: #fa4226;\n          }\n\n          a {\n            text-decoration: none;\n            color: white;\n            font-weight: 700;\n          }\n        }\n        &__h2 {\n          color: #ccc;\n          margin-top: 8;\n          font-weight: 600;\n          height: 65px;\n        }\n      }\n      &__specification {\n        display: flex;\n        gap: 2rem;\n        padding: 1rem;\n        justify-content: space-between;\n        margin-top: -12px;\n        i {\n          font-size: 1.5rem;\n        }\n      }\n    }\n  }\n}\n\n.dialog_modal {\n  text-align: center;\n  border-radius: 18px;\n  padding: 3rem;\n  h2 {\n    color: #13c39c;\n    font-size: 2.5rem;\n    margin-top: 2rem;\n    font-weight: 600;\n  }\n  p {\n    color: #ababab;\n    margin-top: 0.5rem;\n    margin-bottom: 4rem;\n    max-width: 312px;\n    font-size: 12px;\n  }\n  button {\n    border: none;\n    background-color: #13c39c;\n    color: #fff;\n    padding: 10px 24px;\n    border-radius: 4px;\n    font-weight: 600;\n  }\n}\n","@use \"../global/\" as *;\n\n.team-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-rows: auto;\n  gap: 4rem;\n  align-items: center;\n  text-align: center;\n  padding: 10rem 2rem;\n  width: 110rem;\n  margin: 0 auto;\n\n  @media (max-width: 1150px) {\n    grid-template-columns: 1fr 1fr;\n    width: fit-content;\n  }\n\n  @media (max-width: 800px) {\n    grid-template-columns: 1fr;\n    width: fit-content;\n  }\n\n  &__box {\n    width: 33rem;\n    background-color: white;\n    box-shadow: 0px 20px 10px 0px rgb(0 0 0 / 8%);\n\n    @media (max-width: 400px) {\n      width: 100%;\n    }\n\n    &__img-div {\n      width: 100%;\n      height: auto;\n      background-color: #f6f6f6;\n      img {\n        width: 100%;\n      }\n    }\n\n    &__descr {\n      color: $text-black;\n      padding: 3rem;\n\n      h3 {\n        font-size: $h4-size;\n      }\n\n      p {\n        font-size: $p-size;\n        font-weight: 500;\n        color: #777777;\n      }\n    }\n  }\n}\n","@use \"../global\" as *;\n\n.contact-div {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n  margin: 0 auto;\n  color: $text-black;\n  padding: 10rem 2rem;\n  background-image: url(\"../../images/banners/bg-contact.png\");\n  background-size: auto;\n  background-position: center center;\n  background-repeat: no-repeat;\n\n  @media (max-width: 950px) {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n\n  &__text {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    max-width: 41rem;\n\n    @media (max-width: 950px) {\n      margin: 0 auto;\n      margin-bottom: 2rem;\n    }\n\n    h2 {\n      font-size: $h2-size;\n      line-height: 1.3;\n      margin-bottom: 2rem;\n    }\n\n    p {\n      font-size: $p-size;\n      font-family: $text-font;\n      color: $text-gray;\n      line-height: 1.6;\n      margin-bottom: 2rem;\n    }\n\n    a {\n      text-decoration: none;\n      color: $text-black;\n      font-size: $p-size;\n      font-weight: 500;\n      transition: all 0.2s;\n      margin-bottom: 0.5rem;\n\n      &:hover {\n        color: $text-orange;\n      }\n    }\n  }\n\n  &__form {\n    display: flex;\n    flex-direction: column;\n\n    form {\n      display: flex;\n      flex-direction: column;\n\n      label {\n        font-size: $p-size;\n        font-weight: 600;\n        margin-bottom: 1rem;\n\n        b {\n          color: $text-orange;\n        }\n      }\n\n      input {\n        background-color: #f2f2f2;\n        padding: 19px 30px 19px 30px;\n        font-size: $p-size;\n        border: none;\n        outline: none;\n        margin-bottom: 2.3rem;\n      }\n\n      textarea {\n        background-color: #f2f2f2;\n        height: 18rem;\n        padding: 19px 30px 19px 30px;\n        font-size: $p-size;\n        border: none;\n        outline: none;\n        margin-bottom: 2.5rem;\n      }\n\n      button {\n        background-color: #f5272b;\n        padding: 1.8rem 3rem;\n        border-radius: 0.3rem;\n        box-shadow: 0 10px 15px 0 rgb(255 83 48 / 35%);\n        transition: all 0.3s;\n        border: 2px solid #f5272b;\n        color: white;\n        font-size: 1.8rem;\n        font-weight: 600;\n        cursor: pointer;\n\n        &:hover {\n          box-shadow: 0 10px 15px 0 rgb(255 83 48 / 60%);\n          background-color: #fa4226;\n        }\n      }\n    }\n  }\n}\n","@use \"../global\" as *;\n\n.estimate-section {\n  padding: 10rem 0;\n}\n\n.estimate-box {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  // margin-top: 3rem;\n}\n\n.estimate-car {\n  width: 50rem;\n  position: relative;\n\n  @media (max-width: 700px) {\n    width: 100%;\n  }\n}\n\n.estimate-description {\n  width: 100%;\n\n  &__price {\n    width: 100%;\n    background-color: $text-orange;\n    font-size: 1.8rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    padding: 0.3rem 1.9rem;\n    white-space: nowrap;\n\n    span {\n      font-size: 2.5rem;\n      font-weight: 700;\n    }\n  }\n\n  &__table {\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-template-rows: auto;\n    font-size: 1.4rem;\n    // font-family: $text-font;\n\n    &__col {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      text-align: center;\n      grid-template-rows: auto;\n      padding: 0.9rem 0.5rem;\n      border-bottom: 2px solid #706f7b;\n      border-right: 2px solid #706f7b;\n      border-left: 2px solid #706f7b;\n\n      span:nth-child(1) {\n        border-right: 2px solid #706f7b;\n      }\n      h4:nth-child(1) {\n        border-right: 2px solid #706f7b;\n      }\n    }\n  }\n}\n","@use \"../global\" as *;\n$breakpoint-desktop: 1024px;\n$breakpoint-tablet: 768px;\n\n.detail-section {\n  padding: 10rem;\n\n  @media (max-width: 1150px) {\n    padding: 6rem;\n  }\n\n  @media (max-width: 800px) {\n    padding: 1rem;\n  }\n\n  &__btn {\n    background-color: #f5272b;\n    padding: 1rem 4rem;\n    border-radius: 0.3rem;\n    box-shadow: 0 10px 15px 0 rgb(255 83 48 / 35%);\n    transition: all 0.3s;\n    border: 2px solid #f5272b;\n    font-size: 1.4rem;\n    cursor: pointer;\n    text-align: center;\n    &:hover {\n      box-shadow: 0 10px 15px 0 rgb(255 83 48 / 60%);\n      background-color: #fa4226;\n    }\n\n    a {\n      text-decoration: none;\n      color: white;\n      font-weight: 700;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
